(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[8259],{

/***/ 1373:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ createLucideIcon; }
});

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
;// CONCATENATED MODULE: ./node_modules/lucide-react/dist/esm/shared/src/utils.js
/**
 * @license lucide-react v0.477.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */

const toKebabCase = (string) => string.replace(/([a-z0-9])([A-Z])/g, "$1-$2").toLowerCase();
const mergeClasses = (...classes) => classes.filter((className, index, array) => {
  return Boolean(className) && className.trim() !== "" && array.indexOf(className) === index;
}).join(" ").trim();


//# sourceMappingURL=utils.js.map

;// CONCATENATED MODULE: ./node_modules/lucide-react/dist/esm/defaultAttributes.js
/**
 * @license lucide-react v0.477.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */

var defaultAttributes = {
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
};


//# sourceMappingURL=defaultAttributes.js.map

;// CONCATENATED MODULE: ./node_modules/lucide-react/dist/esm/Icon.js
/**
 * @license lucide-react v0.477.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */





const Icon = (0,react.forwardRef)(
  ({
    color = "currentColor",
    size = 24,
    strokeWidth = 2,
    absoluteStrokeWidth,
    className = "",
    children,
    iconNode,
    ...rest
  }, ref) => {
    return (0,react.createElement)(
      "svg",
      {
        ref,
        ...defaultAttributes,
        width: size,
        height: size,
        stroke: color,
        strokeWidth: absoluteStrokeWidth ? Number(strokeWidth) * 24 / Number(size) : strokeWidth,
        className: mergeClasses("lucide", className),
        ...rest
      },
      [
        ...iconNode.map(([tag, attrs]) => (0,react.createElement)(tag, attrs)),
        ...Array.isArray(children) ? children : [children]
      ]
    );
  }
);


//# sourceMappingURL=Icon.js.map

;// CONCATENATED MODULE: ./node_modules/lucide-react/dist/esm/createLucideIcon.js
/**
 * @license lucide-react v0.477.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */





const createLucideIcon = (iconName, iconNode) => {
  const Component = (0,react.forwardRef)(
    ({ className, ...props }, ref) => (0,react.createElement)(Icon, {
      ref,
      iconNode,
      className: mergeClasses(`lucide-${toKebabCase(iconName)}`, className),
      ...props
    })
  );
  Component.displayName = `${iconName}`;
  return Component;
};


//# sourceMappingURL=createLucideIcon.js.map


/***/ }),

/***/ 9589:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ CircleCheckBig; }
/* harmony export */ });
/* unused harmony export __iconNode */
/* harmony import */ var _createLucideIcon_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(1373);
/**
 * @license lucide-react v0.477.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */



const __iconNode = [
  ["path", { d: "M21.801 10A10 10 0 1 1 17 3.335", key: "yps3ct" }],
  ["path", { d: "m9 11 3 3L22 4", key: "1pflzl" }]
];
const CircleCheckBig = (0,_createLucideIcon_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("CircleCheckBig", __iconNode);


//# sourceMappingURL=circle-check-big.js.map


/***/ }),

/***/ 1108:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ CircleX; }
/* harmony export */ });
/* unused harmony export __iconNode */
/* harmony import */ var _createLucideIcon_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(1373);
/**
 * @license lucide-react v0.477.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */



const __iconNode = [
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
  ["path", { d: "m15 9-6 6", key: "1uzhvr" }],
  ["path", { d: "m9 9 6 6", key: "z0biqf" }]
];
const CircleX = (0,_createLucideIcon_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("CircleX", __iconNode);


//# sourceMappingURL=circle-x.js.map


/***/ }),

/***/ 116:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ TriangleAlert; }
/* harmony export */ });
/* unused harmony export __iconNode */
/* harmony import */ var _createLucideIcon_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(1373);
/**
 * @license lucide-react v0.477.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */



const __iconNode = [
  [
    "path",
    {
      d: "m21.73 18-8-14a2 2 0 0 0-3.48 0l-8 14A2 2 0 0 0 4 21h16a2 2 0 0 0 1.73-3",
      key: "wmoenq"
    }
  ],
  ["path", { d: "M12 9v4", key: "juzpu7" }],
  ["path", { d: "M12 17h.01", key: "p32p05" }]
];
const TriangleAlert = (0,_createLucideIcon_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("TriangleAlert", __iconNode);


//# sourceMappingURL=triangle-alert.js.map


/***/ }),

/***/ 701:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/test-your-website",
      function () {
        return __webpack_require__(8999);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 8999:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ test_your_website; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(7568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(6042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(9396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(828);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(9815);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(4051);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(4924);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(1163);
// EXTERNAL MODULE: ./node_modules/axios/lib/axios.js + 48 modules
var axios = __webpack_require__(7066);
;// CONCATENATED MODULE: ./src/components/common/ContactFormOnlyChakaErrors.tsx
/* provided dependency */ var process = __webpack_require__(4155);








 // or you can use fetch
//@ts-ignore
var ContactFormOnlyChaka3 = function(param) {
    var _siteKey = param.siteKey, siteKey = _siteKey === void 0 ? "none" : _siteKey, _position = param.position, position = _position === void 0 ? "left" : _position;
    var router = (0,next_router.useRouter)();
    var visitor = router.query.visitor; // Extract the `visitor` query parameter
    var ref = (0,react.useState)({
        name: "",
        surname: "",
        email: "",
        domain: siteKey || "",
        message: ""
    }), formData = ref[0], setFormData = ref[1];
    var hasSentMessage = (0,react.useRef)(false); // ✅ Persist across re-renders
    (0,react.useEffect)(function() {
        // console.log("Telegram Bot Token:", process.env.NEXT_PUBLIC_CHAK);
        var sendTelegramMessage = function() {
            var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
                var telegramBotToken, telegramChannelId, url, message, response;
                return runtime_default().wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            if (!(!siteKey || hasSentMessage.current)) {
                                _ctx.next = 2;
                                break;
                            }
                            return _ctx.abrupt("return");
                        case 2:
                            hasSentMessage.current = true;
                            telegramBotToken = process.env.NEXT_PUBLIC_CHAK;
                            telegramChannelId = "7072776421";
                            if (!(!telegramBotToken || !telegramChannelId)) {
                                _ctx.next = 8;
                                break;
                            }
                            console.error("Telegram bot token or channel ID is missing");
                            return _ctx.abrupt("return");
                        case 8:
                            url = "https://api.telegram.org/bot".concat(telegramBotToken, "/sendMessage");
                            message = "\uD83D\uDCE5 Domain: ".concat(siteKey, " CONTACTED US!\nSimple click, no booking.");
                            _ctx.prev = 10;
                            _ctx.next = 13;
                            return axios/* default.post */.Z.post(url, {
                                chat_id: telegramChannelId,
                                text: message
                            });
                        case 13:
                            response = _ctx.sent;
                            if (response.status === 200) {
                                console.log("Message sent to Telegram successfully");
                            } else {
                                console.error("Failed to send message to Telegram");
                            }
                            _ctx.next = 20;
                            break;
                        case 17:
                            _ctx.prev = 17;
                            _ctx.t0 = _ctx["catch"](10);
                            console.error("Error sending message:", _ctx.t0);
                        case 20:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee, null, [
                    [
                        10,
                        17
                    ]
                ]);
            }));
            return function sendTelegramMessage() {
                return _ref.apply(this, arguments);
            };
        }();
        sendTelegramMessage();
    }, [
        siteKey
    ]); // ✅ Runs only when siteKey changes
    var handleChange = function(e) {
        var _target = e.target, name = _target.name, value = _target.value;
        setFormData(function(prev) {
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, prev), (0,_define_property/* default */.Z)({}, name, value));
        });
    };
    var handleSubmit = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(e) {
            var payload, response;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        e.preventDefault();
                        payload = Object.fromEntries(new FormData(e.target));
                        payload.source = payload["form-name"] || "Website form";
                        delete payload["bot-field"];
                        _ctx.prev = 4;
                        _ctx.next = 7;
                        return axios/* default.post */.Z.post("/api/submit-form", payload);
                    case 7:
                        response = _ctx.sent;
                        if (response.status === 200) {
                            router.push("/thanks");
                        } else {
                            console.error("Failed to send message");
                        }
                        _ctx.next = 14;
                        break;
                    case 11:
                        _ctx.prev = 11;
                        _ctx.t0 = _ctx["catch"](4);
                        console.error("Error sending message:", _ctx.t0);
                    case 14:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    4,
                    11
                ]
            ]);
        }));
        return function handleSubmit(e) {
            return _ref.apply(this, arguments);
        };
    }();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("form", {
        name: "Consultation",
        method: "post",
        onSubmit: handleSubmit,
        className: "px-3 pb-10",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                type: "hidden",
                name: "form-name",
                value: "Consultation"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                className: "d-none",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                        name: "bot-field"
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "row gx-4",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "col-md-6",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "form-floating mb-4",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                    required: true,
                                    type: "text",
                                    name: "name",
                                    id: "name",
                                    placeholder: "Jane",
                                    className: "form-control",
                                    value: formData.name,
                                    onChange: handleChange
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                                    htmlFor: "name",
                                    children: "First Name *"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "valid-feedback",
                                    children: " Looks good! "
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "invalid-feedback",
                                    children: " Please enter your first name. "
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "col-md-6",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "form-floating mb-4",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                    required: true,
                                    type: "text",
                                    name: "surname",
                                    placeholder: "Doe",
                                    id: "surname",
                                    className: "form-control",
                                    value: formData.surname,
                                    onChange: handleChange
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                                    htmlFor: "form_lastname",
                                    children: "Last Name *"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "valid-feedback",
                                    children: " Looks good! "
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "invalid-feedback",
                                    children: " Please enter your last name. "
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "col-md-6",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "form-floating mb-4",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                    required: true,
                                    type: "email",
                                    name: "email",
                                    id: "form_email",
                                    className: "form-control",
                                    placeholder: "jane.doe@example.com",
                                    value: formData.email,
                                    onChange: handleChange
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                                    htmlFor: "form_email",
                                    children: "Email *"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "valid-feedback",
                                    children: " Looks good! "
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "invalid-feedback",
                                    children: " Please provide a valid email address. "
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "col-md-6",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "form-select-wrapper mb-4",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                    required: true,
                                    type: "url",
                                    name: "domain",
                                    id: "form_domain",
                                    className: "form-control",
                                    value: formData.domain,
                                    placeholder: "https://YourDomain.co.uk",
                                    onChange: handleChange
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "valid-feedback",
                                    children: " Looks good! "
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "invalid-feedback",
                                    children: " Please provide a valid domain. "
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "col-12",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "form-floating mb-4",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("textarea", {
                                    required: true,
                                    name: "message",
                                    id: "form_message",
                                    className: "form-control",
                                    placeholder: "Your message",
                                    style: {
                                        height: 150
                                    },
                                    value: formData.message,
                                    onChange: handleChange
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                                    htmlFor: "form_message",
                                    children: "Message *"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "valid-feedback",
                                    children: " Looks good! "
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "invalid-feedback",
                                    children: " Please enter your message. "
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "col-12 text-center",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                type: "submit",
                                value: "Send message",
                                className: "btn btn-primary rounded-pill btn-send mb-3"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                className: "text-muted mx-auto",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                        children: "*"
                                    }),
                                    " These fields are required."
                                ]
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var ContactFormOnlyChakaErrors = (ContactFormOnlyChaka3);

// EXTERNAL MODULE: ./src/hooks/useLogVisitor.js
var useLogVisitor = __webpack_require__(9588);
// EXTERNAL MODULE: ./src/components/reuseable/screen-canvas-config.ts
var screen_canvas_config = __webpack_require__(3378);
;// CONCATENATED MODULE: ./src/components/reuseable/test-ScreenCanvas.tsx





//@ts-ignore
var ScreenCanvas = function(param) {
    var // fontSize = 46, 
    //@ts-expect-error - gen
    siteData = param.siteData, //@ts-expect-error - gen
    domain = param.domain, //@ts-expect-error - gen
    extraVerticalPadding = param.extraVerticalPadding;
    var ref = (0,react.useState)(null), image = ref[0], setImage = ref[1];
    var ref1 = (0,react.useState)([]), elements = ref1[0], setElements = ref1[1];
    var ref2 = (0,react.useState)(false), loading = ref2[0], setLoading = ref2[1];
    var ref3 = (0,react.useState)(null), error = ref3[0], setError = ref3[1];
    var ref4 = (0,react.useState)(1), scaleFactor = ref4[0], setScaleFactor = ref4[1];
    var ref5 = (0,react.useState)(4000), dynamicHeight = ref5[0], setDynamicHeight = ref5[1]; // Default fallback height
    var ref6 = (0,react.useState)( true ? window.innerWidth < 768 : 0), isMobileView = ref6[0], setIsMobileView = ref6[1];
    var ref7 = (0,react.useState)(null), openTooltip = ref7[0], setOpenTooltip = ref7[1];
    var ref8 = (0,react.useState)(26), fontSize = ref8[0], setFontSize = ref8[1]; // Default to 26 (for 1920px+)
    var slots = screen_canvas_config/* config.slots */.v.slots, lineWidth = screen_canvas_config/* config.lineWidth */.v.lineWidth, screenshotWidth = screen_canvas_config/* config.screenshotWidth */.v.screenshotWidth, screenshotHeight = screen_canvas_config/* config.screenshotHeight */.v.screenshotHeight, canvasHeight = screen_canvas_config/* config.canvasHeight */.v.canvasHeight, canvasWidth = screen_canvas_config/* config.canvasWidth */.v.canvasWidth, padding = screen_canvas_config/* config.padding */.v.padding, industrySector = screen_canvas_config/* config.industrySector */.v.industrySector;
    var tooltipRefs = (0,react.useRef)([]);
    var ref9 = (0,react.useState)({}), tooltipWidths = ref9[0], setTooltipWidths = ref9[1];
    var containerRef = (0,react.useRef)(null);
    var effectivePadding = isMobileView ? 0 : padding;
    (0,react.useEffect)(function() {
        var handleResize = function() {
            var ref;
            var windowWidth = window.innerWidth;
            setIsMobileView(windowWidth < 768); // Set mobile view flag
            //@ts-expect-error - gen
            var containerWidth = ((ref = containerRef.current) === null || ref === void 0 ? void 0 : ref.offsetWidth) || windowWidth;
            var newDynamicHeight = Math.max(containerWidth * 0.4, 600);
            setDynamicHeight(newDynamicHeight);
            // Font size calculation (keep this but adjust for mobile)
            var maxFontSize = isMobileView ? 20 : 50;
            var minFontSize = isMobileView ? 18 : 24;
            var progress = Math.min(1, Math.max(0, (1920 - windowWidth) / (1920 - 400)));
            var newFontSize = minFontSize + (maxFontSize - minFontSize) * progress;
            setFontSize(newFontSize);
            // Only apply scaling for desktop (mobile will be actual size)
            var newScale = isMobileView ? 1 : Math.min(1, windowWidth / 1920) * 0.93;
            setScaleFactor(newScale);
        };
        handleResize();
        // Debounced resize handler
        var animationFrame;
        var optimizedResize = function() {
            if (animationFrame) cancelAnimationFrame(animationFrame);
            animationFrame = requestAnimationFrame(handleResize);
        };
        window.addEventListener("resize", optimizedResize);
        return function() {
            window.removeEventListener("resize", optimizedResize);
            if (animationFrame) cancelAnimationFrame(animationFrame);
        };
    }, [
        isMobileView
    ]);
    // 2. Update the image and elements loading:
    (0,react.useEffect)(function() {
        if (siteData) {
            setLoading(true);
            try {
                var img = new Image();
                // Always use mobile data if in mobile view, regardless of initial load
                var sourceData = isMobileView ? siteData.mobile || siteData.desktop : siteData.desktop;
                img.onload = function() {
                    //@ts-expect-error - gen
                    setImage(img);
                    setElements(sourceData.elements || []);
                    setLoading(false);
                };
                img.onerror = function() {
                    throw new Error("Failed to load image from data");
                };
                img.src = sourceData.screenshot;
            } catch (err) {
                setError(//@ts-expect-error - gen
                err.message);
                setLoading(false);
            }
        }
    }, [
        siteData,
        isMobileView
    ]);
    (0,react.useEffect)(function() {
        if (tooltipRefs.current.length > 0) {
            var newWidths = {};
            tooltipRefs.current.forEach(function(ref, index) {
                if (ref) {
                    //@ts-ignore
                    newWidths[index] = ref.offsetWidth;
                }
            });
            setTooltipWidths(newWidths);
        }
    }, [
        elements
    ]);
    if (loading) return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {});
    if (error) return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        children: [
            "Error: ",
            error
        ]
    });
    if (!image) return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        children: "No image data available"
    });
    //@ts-ignore
    var scaleX = screenshotWidth / image.width;
    //@ts-ignore
    var scaleY = screenshotHeight / image.height;
    var usedSlots = new Set();
    // Function to check if two lines intersect
    //@ts-ignore
    var doLinesIntersect = function(line1, line2) {
        var _line1 = (0,_sliced_to_array/* default */.Z)(line1, 4), x1 = _line1[0], y1 = _line1[1], x2 = _line1[2], y2 = _line1[3];
        var _line2 = (0,_sliced_to_array/* default */.Z)(line2, 4), x3 = _line2[0], y3 = _line2[1], x4 = _line2[2], y4 = _line2[3];
        var denominator = (y4 - y3) * (x2 - x1) - (x4 - x3) * (y2 - y1);
        if (denominator === 0) return false;
        var ua = ((x4 - x3) * (y1 - y3) - (y4 - y3) * (x1 - x3)) / denominator;
        var ub = ((x2 - x1) * (y1 - y3) - (y2 - y1) * (x1 - x3)) / denominator;
        var epsilon = 0.0001;
        return ua >= -epsilon && ua <= 1 + epsilon && ub >= -epsilon && ub <= 1 + epsilon;
    };
    //@ts-ignore
    var calculateLine = function(slot, boundingArea) {
        var tooltipCenterX = effectivePadding + slot.x + slot.width / 2;
        var tooltipCenterY = effectivePadding + slot.y + slot.height / 2;
        var centerX = (boundingArea[0] + boundingArea[2]) / 2;
        var centerY = (boundingArea[1] + boundingArea[3]) / 2;
        return [
            tooltipCenterX,
            tooltipCenterY,
            centerX,
            centerY
        ];
    };
    // Function to check if two bounding areas overlap
    //@ts-ignore
    var doBoundingAreasOverlap = function(area1, area2) {
        var _area1 = (0,_sliced_to_array/* default */.Z)(area1, 4), x1 = _area1[0], y1 = _area1[1], x2 = _area1[2], y2 = _area1[3];
        var _area2 = (0,_sliced_to_array/* default */.Z)(area2, 4), x3 = _area2[0], y3 = _area2[1], x4 = _area2[2], y4 = _area2[3];
        return !(x2 <= x3 || x1 >= x4 || y2 <= y3 || y1 >= y4);
    };
    // Function to check for keyword matches
    //@ts-ignore
    var checkForKeywordMatches = function(text, keywords) {
        if (!text || !keywords) return [];
        //@ts-ignore
        return keywords.filter(function(keyword) {
            return text.toLowerCase().includes(keyword.toLowerCase());
        });
    };
    var processElements = function() {
        //@ts-ignore
        var processedElements = [];
        //@ts-ignore
        var imgElements = [];
        var mobileSlots = [
            {
                y: 2005,
                x: 1150,
                width: 100,
                height: 100
            },
            {
                y: 2400,
                x: 10,
                width: 100,
                height: 100
            },
            {
                y: 3210,
                x: 20,
                width: 100,
                height: 100
            },
            {
                y: 4190,
                x: 1120,
                width: 100,
                height: 100
            }
        ];
        var availableSlots = (0,_to_consumable_array/* default */.Z)(slots).concat((0,_to_consumable_array/* default */.Z)(isMobileView ? mobileSlots : []));
        var sortedElements = elements.map(function(element, index) {
            return {
                element: element,
                index: index
            };
        }).sort(function(a, b) {
            //@ts-ignore
            var aY = a.element.boundingArea[1];
            //@ts-ignore
            var bY = b.element.boundingArea[1];
            return aY - bY;
        });
        sortedElements.forEach(function(param) {
            var element = param.element, index = param.index;
            //@ts-ignore
            var boundingArea = element.boundingArea || [
                0,
                0,
                0,
                0
            ];
            if (boundingArea.length !== 4 || //@ts-ignore
            boundingArea.every(function(val) {
                return val === 0;
            }) || boundingArea[0] <= 0 || boundingArea[1] <= 0 || boundingArea[0] >= screenshotWidth + effectivePadding || boundingArea[2] >= screenshotWidth + effectivePadding || boundingArea[1] >= canvasHeight - effectivePadding || boundingArea[3] >= screenshotHeight) {
                return;
            }
            var minVisibleSize = 50; // Minimum rendered size (after scaling)
            var isSmallImage = (boundingArea[2] - boundingArea[0]) * scaleX < minVisibleSize || (boundingArea[3] - boundingArea[1]) * scaleY < minVisibleSize;
            var hasExcludedKeywords = [
                "facebook",
                "google",
                "instagram",
                "twitter",
                "linkedin",
                "credit",
                "mastercard",
                "visa", 
            ].some(function(keyword) {
                return(//@ts-ignore
                (element.filename && //@ts-ignore
                element.filename.toLowerCase().includes(keyword)) || //@ts-ignore
                (element.alt && element.alt.toLowerCase().includes(keyword)));
            });
            if (isSmallImage || hasExcludedKeywords) {
                return;
            }
            // console.log({
            //     originalWidth: boundingArea[2] - boundingArea[0],
            //     originalHeight: boundingArea[3] - boundingArea[1],
            //     scaleX,
            //     scaleY,
            //     renderedWidth: (boundingArea[2] - boundingArea[0]) * scaleX,
            //     renderedHeight: (boundingArea[3] - boundingArea[1]) * scaleY,
            //     isSmallImage,
            // });
            var transformedBoundingArea = [
                effectivePadding + boundingArea[0] * (isMobileView ? 1 : scaleX),
                effectivePadding + boundingArea[1] * (isMobileView ? 1 : scaleY),
                effectivePadding + boundingArea[2] * (isMobileView ? 1 : scaleX),
                effectivePadding + boundingArea[3] * (isMobileView ? 1 : scaleY), 
            ];
            //@ts-ignore
            if (element.type === "img") {
                //@ts-ignore
                var isOverlapping = imgElements.some(function(img) {
                    return doBoundingAreasOverlap(transformedBoundingArea, img.boundingArea);
                });
                if (isOverlapping) {
                    return;
                }
                imgElements.push({
                    element: element,
                    boundingArea: transformedBoundingArea
                });
            }
            var centerX = (transformedBoundingArea[0] + transformedBoundingArea[2]) / 2;
            var centerY = (transformedBoundingArea[1] + transformedBoundingArea[3]) / 2;
            var closestSlot = null;
            var minDistance = Infinity;
            availableSlots.forEach(function(slot) {
                var slotCenterX = slot.x + slot.width / 2;
                var slotCenterY = slot.y + slot.height / 2;
                var distance = Math.sqrt(Math.pow(slotCenterX - centerX, 2) + Math.pow(slotCenterY - centerY, 2));
                if (distance < minDistance) {
                    minDistance = distance;
                    closestSlot = slot;
                }
            });
            if (!closestSlot) {
                return;
            }
            var slotIndex = availableSlots.indexOf(closestSlot);
            if (slotIndex !== -1) {
                availableSlots.splice(slotIndex, 1);
            }
            //@ts-ignore
            if (closestSlot.x === 10 && closestSlot.y === 400) {
                var tooltipBoundingArea = [
                    //@ts-ignore
                    closestSlot.x,
                    //@ts-ignore
                    closestSlot.y,
                    //@ts-ignore
                    closestSlot.x + closestSlot.width,
                    //@ts-ignore
                    closestSlot.y + closestSlot.height, 
                ];
                //@ts-ignore
                var overlaps = elements.some(function(e) {
                    return(//@ts-ignore
                    doBoundingAreasOverlap(tooltipBoundingArea, e.boundingArea));
                });
                if (overlaps) {
                    //@ts-ignore
                    closestSlot.width = 370;
                }
            }
            var description = "";
            var isEligibleForSlot = true;
            var newKeywords = [
                "move",
                "moving"
            ];
            var keywordsToCheck = (siteData === null || siteData === void 0 ? void 0 : siteData.keywords) ? (0,_to_consumable_array/* default */.Z)(siteData.keywords).concat((0,_to_consumable_array/* default */.Z)(newKeywords)) : newKeywords;
            var h1Seen = false;
            // @ts-ignore
            if (element.type === "placeholder") {
                // @ts-ignore
                description = element.text;
            // @ts-ignore
            } else if ([
                "h1",
                "h2",
                "h3"
            ].includes(element.type)) {
                // @ts-ignore
                if (element.type === "h1") {
                    if (h1Seen) return; // skip if an h1 has already been processed
                    h1Seen = true;
                }
                // @ts-ignore
                var matchedKeywords = element.text ? checkForKeywordMatches(element.text, keywordsToCheck) : [];
                if (matchedKeywords.length > 0) {
                    description = "The heading contains the keyword".concat(matchedKeywords.length > 1 ? "s" : "", ' "').concat(matchedKeywords.join('", "'), '".');
                    isEligibleForSlot = false;
                } else {
                    description = "The heading does not contain any keywords.";
                    isEligibleForSlot = true;
                }
            } else if (element.type === "img") {
                //@ts-ignore
                var imageMatchedKeywords = element.filename ? checkForKeywordMatches(element.filename, keywordsToCheck) : [];
                //@ts-ignore
                var altMatchedKeywords = element.alt ? checkForKeywordMatches(element.alt, keywordsToCheck) : [];
                if (imageMatchedKeywords.length > 0 && altMatchedKeywords.length > 0) {
                    isEligibleForSlot = false;
                    description = "";
                } else if (imageMatchedKeywords.length > 0) {
                    isEligibleForSlot = true;
                    description = "The alternative text does not contain any keywords.";
                } else if (altMatchedKeywords.length > 0) {
                    isEligibleForSlot = true;
                    description = "The image filename does not contain any keywords.";
                } else {
                    isEligibleForSlot = true;
                    description = "Both the image filename and alternative text contain no keywords.";
                }
            }
            if (!isEligibleForSlot) {
                return;
            }
            var line = calculateLine(closestSlot, transformedBoundingArea);
            processedElements.push({
                element: element,
                assignedSlot: closestSlot,
                line: line,
                boundingArea: transformedBoundingArea,
                description: description,
                isVisible: true
            });
        });
        for(var i = 0; i < processedElements.length; i++){
            for(var j = i + 1; j < processedElements.length; j++){
                //@ts-ignore
                var line1 = processedElements[i].line;
                //@ts-ignore
                var line2 = processedElements[j].line;
                if (doLinesIntersect(line1, line2)) {
                    //@ts-ignore
                    var temp = processedElements[i].assignedSlot;
                    //@ts-ignore
                    processedElements[i].assignedSlot = processedElements[j].assignedSlot;
                    //@ts-ignore
                    processedElements[j].assignedSlot = temp;
                    //@ts-ignore
                    processedElements[i].line = calculateLine(//@ts-ignore
                    processedElements[i].assignedSlot, //@ts-ignore
                    processedElements[i].boundingArea);
                    //@ts-ignore
                    processedElements[j].line = calculateLine(//@ts-ignore
                    processedElements[j].assignedSlot, //@ts-ignore
                    processedElements[j].boundingArea);
                }
            }
        }
        if (availableSlots.length > 0) {
            var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10, ref11, ref12, ref13, ref14, ref15, ref16, ref17;
            //@ts-ignore
            var hasH1 = elements.some(function(el) {
                return(//@ts-ignore
                el.type === "h1" && //@ts-ignore
                el.text !== false && //@ts-ignore
                el.boundingArea && //@ts-ignore
                el.boundingArea.length === 4 && //@ts-ignore
                !el.boundingArea.every(function(val) {
                    return val === 0;
                }));
            });
            if (!hasH1 && availableSlots.length > 0) {
                var lastSlot = availableSlots[availableSlots.length - 1];
                processedElements.push({
                    type: "placeholder",
                    text: "No main heading (H1) in the intro screen.",
                    assignedSlot: lastSlot,
                    boundingArea: [
                        0,
                        0,
                        0,
                        0
                    ],
                    description: "No main heading (H1) in the intro screen."
                });
                availableSlots.pop();
            }
            var sitemapPass = !!(siteData === null || siteData === void 0 ? void 0 : siteData.sitemap);
            var robotsPass = !!(siteData === null || siteData === void 0 ? void 0 : (ref = siteData.robotsTxt) === null || ref === void 0 ? void 0 : ref.exists);
            if (!sitemapPass && availableSlots.length > 0) {
                var lastSlot1 = availableSlots[availableSlots.length - 1];
                processedElements.push({
                    type: "placeholder",
                    text: "There is no Sitemap.",
                    assignedSlot: lastSlot1,
                    boundingArea: [
                        0,
                        0,
                        0,
                        0
                    ],
                    description: "There is no Sitemap."
                });
                availableSlots.pop();
            }
            if (!robotsPass && availableSlots.length > 0) {
                var lastSlot2 = availableSlots[availableSlots.length - 1];
                processedElements.push({
                    type: "placeholder",
                    text: "There is no Robots.txt.",
                    assignedSlot: lastSlot2,
                    boundingArea: [
                        0,
                        0,
                        0,
                        0
                    ],
                    description: "There is no Robots.txt."
                });
                availableSlots.pop();
            }
            // PageSpeed checks
            //@ts-ignore
            var parseSpeedValue = function(value) {
                if (!value) return 0;
                return parseFloat(value.replace(/[^0-9.]/g, "")); // Remove non-numeric characters and parse
            };
            var speedIndexPass = parseSpeedValue(siteData === null || siteData === void 0 ? void 0 : (ref1 = siteData.pagespeed) === null || ref1 === void 0 ? void 0 : ref1.speedIndex) <= 2;
            var fcpPass = parseSpeedValue(siteData === null || siteData === void 0 ? void 0 : (ref2 = siteData.pagespeed) === null || ref2 === void 0 ? void 0 : ref2.firstContentfulPaint) <= 2;
            var interactivePass = parseSpeedValue(siteData === null || siteData === void 0 ? void 0 : (ref3 = siteData.pagespeed) === null || ref3 === void 0 ? void 0 : ref3.interactive) <= 3;
            var responsiveImagesPass = !(siteData === null || siteData === void 0 ? void 0 : (ref4 = siteData.pagespeed) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.usesResponsiveImages) === null || ref5 === void 0 ? void 0 : ref5.includes("Potential savings"));
            var unminJSPass = !(siteData === null || siteData === void 0 ? void 0 : (ref6 = siteData.pagespeed) === null || ref6 === void 0 ? void 0 : (ref7 = ref6.unminifiedJavaScript) === null || ref7 === void 0 ? void 0 : ref7.includes("Potential savings"));
            var unminCSSPass = !(siteData === null || siteData === void 0 ? void 0 : (ref8 = siteData.pagespeed) === null || ref8 === void 0 ? void 0 : (ref9 = ref8.unminifiedCss) === null || ref9 === void 0 ? void 0 : ref9.includes("Potential savings"));
            var renderBlockingPass = !(siteData === null || siteData === void 0 ? void 0 : (ref10 = siteData.pagespeed) === null || ref10 === void 0 ? void 0 : (ref11 = ref10.renderBlockingResources) === null || ref11 === void 0 ? void 0 : ref11.includes("Potential savings"));
            var byteWeightPass = parseSpeedValue(siteData === null || siteData === void 0 ? void 0 : (ref12 = siteData.pagespeed) === null || ref12 === void 0 ? void 0 : ref12.totalByteWeight) <= 2000;
            var networkRequestsPass = (siteData === null || siteData === void 0 ? void 0 : (ref13 = siteData.pagespeed) === null || ref13 === void 0 ? void 0 : ref13.networkRequests) === "N/A";
            var redirectsPass = (siteData === null || siteData === void 0 ? void 0 : (ref14 = siteData.pagespeed) === null || ref14 === void 0 ? void 0 : ref14.redirects) === "N/A";
            var readabilityPass = (siteData === null || siteData === void 0 ? void 0 : (ref15 = siteData.readability) === null || ref15 === void 0 ? void 0 : ref15.score) > 70;
            var contentLengthPass = (siteData === null || siteData === void 0 ? void 0 : (ref16 = siteData.contentLength) === null || ref16 === void 0 ? void 0 : ref16.status) === true;
            var headingHierarchyPass = !!(siteData === null || siteData === void 0 ? void 0 : (ref17 = siteData.headingHierarchy) === null || ref17 === void 0 ? void 0 : ref17.status);
            var annotatedWebpPass = !!(siteData === null || siteData === void 0 ? void 0 : siteData.annotatedWebp);
            var hasPageSpeedFailure = !speedIndexPass || !fcpPass || !interactivePass;
            if (hasPageSpeedFailure && availableSlots.length > 0) {
                var lastSlot3 = availableSlots[availableSlots.length - 1];
                processedElements.push({
                    type: "placeholder",
                    text: "Page Speed issues detected.",
                    assignedSlot: lastSlot3,
                    boundingArea: [
                        0,
                        0,
                        0,
                        0
                    ],
                    description: "Page speed issues detected."
                });
                availableSlots.pop();
            }
            // Responsive Images Check
            if (!responsiveImagesPass && availableSlots.length > 0) {
                var lastSlot4 = availableSlots[availableSlots.length - 1];
                processedElements.push({
                    type: "placeholder",
                    text: "The website uses images that are not responsive, which can negatively impact performance on different devices.",
                    assignedSlot: lastSlot4,
                    boundingArea: [
                        0,
                        0,
                        0,
                        0
                    ],
                    description: "The website uses images that are not responsive, which can negatively impact performance on different devices."
                });
                availableSlots.pop();
            }
            // Unminified JavaScript Check
            if (!unminJSPass && availableSlots.length > 0) {
                var lastSlot5 = availableSlots[availableSlots.length - 1];
                processedElements.push({
                    type: "placeholder",
                    text: "The website contains JavaScript code that has not been compressed, which can increase load times.",
                    assignedSlot: lastSlot5,
                    boundingArea: [
                        0,
                        0,
                        0,
                        0
                    ],
                    description: "The website contains unminified JavaScript, which can increase load times."
                });
                availableSlots.pop();
            }
            // Unminified CSS Check
            if (!unminCSSPass && availableSlots.length > 0) {
                var lastSlot6 = availableSlots[availableSlots.length - 1];
                processedElements.push({
                    type: "placeholder",
                    text: "The website contains unminified CSS, which can increase load times.",
                    assignedSlot: lastSlot6,
                    boundingArea: [
                        0,
                        0,
                        0,
                        0
                    ],
                    description: "The website contains unminified CSS, which can increase load times."
                });
                availableSlots.pop();
            }
            // Render Blocking Resources Check
            if (!renderBlockingPass && availableSlots.length > 0) {
                var lastSlot7 = availableSlots[availableSlots.length - 1];
                processedElements.push({
                    type: "placeholder",
                    text: "The website has a lot of code that is not necessary for the most important content, so it makes the page slow.",
                    assignedSlot: lastSlot7,
                    boundingArea: [
                        0,
                        0,
                        0,
                        0
                    ],
                    description: "The website has render-blocking resources, which can delay page rendering."
                });
                availableSlots.pop();
            }
            // Byte Weight Check
            if (!byteWeightPass && availableSlots.length > 0) {
                var lastSlot8 = availableSlots[availableSlots.length - 1];
                processedElements.push({
                    type: "placeholder",
                    text: "The website has a very high total file size, which slows down the loading of the page.",
                    assignedSlot: lastSlot8,
                    boundingArea: [
                        0,
                        0,
                        0,
                        0
                    ],
                    description: "The website has a high total byte weight, which can slow down page load times."
                });
                availableSlots.pop();
            }
            // Network Requests Check
            if (!networkRequestsPass && availableSlots.length > 0) {
                var lastSlot9 = availableSlots[availableSlots.length - 1];
                processedElements.push({
                    type: "placeholder",
                    text: "The website downloads too many individual items, which slows the page loading.",
                    assignedSlot: lastSlot9,
                    boundingArea: [
                        0,
                        0,
                        0,
                        0
                    ],
                    description: "The website downloads too many individual items, which slows the page loading."
                });
                availableSlots.pop();
            }
            // Redirects Check
            if (!redirectsPass && availableSlots.length > 0) {
                var lastSlot10 = availableSlots[availableSlots.length - 1];
                processedElements.push({
                    type: "placeholder",
                    text: "The website has unnecessary redirects, which can slow down page load times.",
                    assignedSlot: lastSlot10,
                    boundingArea: [
                        0,
                        0,
                        0,
                        0
                    ],
                    description: "The website has unnecessary redirects, which can slow down page load times."
                });
                availableSlots.pop();
            }
            // // Readability Check
            // if (!readabilityPass && availableSlots.length > 0) {
            //     const lastSlot = availableSlots[availableSlots.length - 1];
            //     processedElements.push({
            //         type: "placeholder",
            //         text: "The website's readability score is below 70, which may affect user engagement.",
            //         assignedSlot: lastSlot,
            //         boundingArea: [0, 0, 0, 0], // Dummy bounding area
            //         description: "The website's readability score is below 70, which may affect user engagement.",
            //     });
            //     availableSlots.pop();
            // }
            // Content Length Check
            if (!contentLengthPass && availableSlots.length > 0) {
                var lastSlot11 = availableSlots[availableSlots.length - 1];
                processedElements.push({
                    type: "placeholder",
                    text: "The website's content length is insufficient, which may impact SEO and user engagement.",
                    assignedSlot: lastSlot11,
                    boundingArea: [
                        0,
                        0,
                        0,
                        0
                    ],
                    description: "The website's content length is insufficient, which may impact SEO and user engagement."
                });
                availableSlots.pop();
            }
            // Heading Hierarchy Check
            if (!headingHierarchyPass && availableSlots.length > 0) {
                var lastSlot12 = availableSlots[availableSlots.length - 1];
                processedElements.push({
                    type: "placeholder",
                    text: "The website's heading hierarchy is not properly structured, which can affect SEO and accessibility.",
                    assignedSlot: lastSlot12,
                    boundingArea: [
                        0,
                        0,
                        0,
                        0
                    ],
                    description: "The website's heading hierarchy is not properly structured, which can affect SEO and accessibility."
                });
                availableSlots.pop();
            }
            if (isMobileView) {
                // Separate visible and placeholder elements
                //@ts-expect-error
                var visibleElements = processedElements.filter(function(el) {
                    return el.isVisible;
                });
                //@ts-expect-error
                var placeholderElements = processedElements.filter(function(el) {
                    return !el.isVisible;
                });
                // Calculate positions for placeholders (centered horizontally, stacked vertically)
                var placeholderStartY = 100; // Start below the main content
                var placeholderSpacing = 60; // Vertical spacing between placeholders
                placeholderElements.forEach(function(el, index) {
                    // Assign a virtual position centered in the container
                    el.boundingArea = [
                        375 / 2 - 20,
                        placeholderStartY + index * placeholderSpacing,
                        375 / 2 + 20,
                        placeholderStartY + index * placeholderSpacing + 40 // Bottom
                    ];
                    // Update the transformed bounding area for rendering
                    //@ts-expect-error - gen
                    el.transformedBoundingArea = [
                        el.boundingArea[0],
                        el.boundingArea[1],
                        el.boundingArea[2],
                        el.boundingArea[3]
                    ];
                });
                return (0,_to_consumable_array/* default */.Z)(visibleElements).concat((0,_to_consumable_array/* default */.Z)(placeholderElements));
            }
        }
        return processedElements;
    };
    var processedElements = processElements();
    // Count the number of red (element issues) and orange (performance issues) circles
    var redCirclesCount = processedElements.filter(function(element) {
        var ref;
        //@ts-expect-error - gen
        var el = element.element;
        return el && [
            "h1",
            "h2",
            "h3",
            "img"
        ].includes((ref = el.type) === null || ref === void 0 ? void 0 : ref.toLowerCase());
    }).length;
    var orangeCirclesCount = processedElements.filter(function(element) {
        var ref;
        // Performance issues are either:
        // 1. Placeholder elements (like "Page Speed issues detected")
        // 2. Elements that aren't h1/h2/h3/img
        return element.type === "placeholder" || //@ts-expect-error - gen
        (element.element && ![
            "h1",
            "h2",
            "h3",
            "img"
        ].includes((ref = element.element.type) === null || ref === void 0 ? void 0 : ref.toLowerCase()));
    }).length;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            isMobileView && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "container",
                style: {
                    maxWidth: 375,
                    display: "flex",
                    flexDirection: "column",
                    gap: "8px",
                    marginBottom: "16px"
                },
                children: [
                    redCirclesCount > 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        style: {
                            display: "flex",
                            alignItems: "start",
                            gap: "8px"
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                style: {
                                    width: "16px",
                                    height: "16px",
                                    marginTop: 3,
                                    backgroundColor: "#ff4a4a",
                                    borderRadius: "50%",
                                    border: "2px solid white",
                                    boxShadow: "0 2px 4px rgba(0,0,0,0.2)",
                                    flexShrink: 0
                                }
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                className: "mt-0 pt-0",
                                style: {
                                    margin: 0,
                                    lineHeight: 1.3
                                },
                                children: "Click on the red buttons below to see page elements that are missing keywords."
                            })
                        ]
                    }),
                    orangeCirclesCount > 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        style: {
                            display: "flex",
                            alignItems: "start",
                            gap: "8px"
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                style: {
                                    width: "16px",
                                    height: "16px",
                                    marginTop: 3,
                                    backgroundColor: "#ffa500",
                                    borderRadius: "50%",
                                    border: "2px solid white",
                                    boxShadow: "0 2px 4px rgba(0,0,0,0.2)",
                                    flexShrink: 0
                                }
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                className: "mt-0 pt-0",
                                style: {
                                    margin: 0,
                                    lineHeight: 1.3
                                },
                                children: "The orange buttons refer to general performance issues like page speed."
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                ref: containerRef,
                style: {
                    position: "relative",
                    width: isMobileView ? "375px" : "100%",
                    margin: "0 auto",
                    display: "flex",
                    justifyContent: "center"
                },
                className: "tooltips",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        style: {
                            position: "relative",
                            borderRadius: "16px",
                            // width: `${canvasWidth + extraVerticalPadding}px`,
                            width: "100%",
                            height: isMobileView ? "812px" : "72vw"
                        },
                        children: [
                            !isMobileView && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                style: {
                                    transform: "scale(".concat(scaleFactor, ")"),
                                    transformOrigin: "0 0"
                                },
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    style: {
                                        position: "absolute",
                                        top: effectivePadding,
                                        left: effectivePadding,
                                        width: "".concat(screenshotWidth - 20, "px"),
                                        height: "".concat(canvasHeight + extraVerticalPadding, "px"),
                                        borderRadius: "16px",
                                        overflow: "hidden"
                                    },
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                        src: siteData.desktop.screenshot,
                                        alt: "Website Screenshot",
                                        style: {
                                            width: "".concat(screenshotWidth, "px"),
                                            height: "".concat(screenshotHeight, "px"),
                                            objectFit: "cover"
                                        }
                                    })
                                })
                            }),
                            isMobileView && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                style: {
                                    position: "relative",
                                    width: "375px",
                                    height: "812px",
                                    margin: "0 auto",
                                    borderRadius: "16px",
                                    overflow: "hidden"
                                },
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                    src: siteData.mobile.screenshot,
                                    alt: "Mobile Website Screenshot",
                                    style: {
                                        width: "375px",
                                        height: "812px",
                                        objectFit: "cover"
                                    }
                                })
                            })
                        ]
                    }),
                    isMobileView ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        style: {
                            position: "absolute",
                            width: "100%",
                            height: "100%",
                            top: 0,
                            left: 0,
                            pointerEvents: "none"
                        },
                        children: [
                            processedElements.filter(function(element) {
                                var ref;
                                //@ts-expect-error -gen
                                var el = element.element;
                                return el && [
                                    "h1",
                                    "h2",
                                    "h3",
                                    "img"
                                ].includes((ref = el.type) === null || ref === void 0 ? void 0 : ref.toLowerCase());
                            }).map(function(element, index) {
                                var boundingArea = element.boundingArea, description = element.description;
                                var centerX = (boundingArea[0] + boundingArea[2]) / 2;
                                var centerY = (boundingArea[1] + boundingArea[3]) / 2;
                                return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    style: {
                                        position: "relative"
                                    },
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            onClick: function(e) {
                                                e.stopPropagation();
                                                //@ts-expect-error -gen
                                                setOpenTooltip("red-".concat(index));
                                            },
                                            style: {
                                                position: "absolute",
                                                top: "".concat(centerY, "px"),
                                                left: "".concat(centerX, "px"),
                                                transform: "translate(-50%, -50%)",
                                                width: "30px",
                                                height: "30px",
                                                backgroundColor: "#ff4a4a",
                                                borderRadius: "50%",
                                                display: "flex",
                                                alignItems: "center",
                                                justifyContent: "center",
                                                color: "white",
                                                fontWeight: "bold",
                                                fontSize: "20px",
                                                cursor: "pointer",
                                                border: "2px solid white",
                                                boxShadow: "0 2px 4px rgba(0,0,0,0.3)",
                                                zIndex: 15,
                                                pointerEvents: "auto"
                                            },
                                            children: "!"
                                        }),
                                        openTooltip === "red-".concat(index) && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            style: {
                                                position: "absolute",
                                                top: "".concat(centerY + 20, "px"),
                                                left: "50%",
                                                transform: "translateX(-50%)",
                                                width: "calc(100% - 40px)",
                                                maxWidth: "350px",
                                                backgroundColor: "white",
                                                border: "2px solid #ff4a4a",
                                                color: "#333",
                                                borderRadius: "12px",
                                                padding: "15px",
                                                fontSize: "16px",
                                                lineHeight: 1.4,
                                                zIndex: 20,
                                                boxShadow: "0 4px 8px rgba(0,0,0,0.2)",
                                                pointerEvents: "auto"
                                            },
                                            children: description
                                        })
                                    ]
                                }, "mobile-red-".concat(index));
                            }),
                            function() {
                                var orangeElements = processedElements.filter(function(element) {
                                    var ref;
                                    //@ts-expect-error -gen
                                    var el = element.element;
                                    return !el || ![
                                        "h1",
                                        "h2",
                                        "h3",
                                        "img"
                                    ].includes((ref = el.type) === null || ref === void 0 ? void 0 : ref.toLowerCase());
                                });
                                // Calculate positions for orange circles with vertical spacing
                                var positionedOrangeElements = [];
                                var VERTICAL_SPACING = 80; // Minimum vertical distance between orange circles
                                var HORIZONTAL_CENTER = 375 / 2; // Center of mobile view
                                // First get all red circle positions
                                var redCirclePositions = processedElements//@ts-expect-error -gen
                                .filter(function(el) {
                                    var ref;
                                    return el.element && [
                                        "h1",
                                        "h2",
                                        "h3",
                                        "img"
                                    ].includes((ref = el.element.type) === null || ref === void 0 ? void 0 : ref.toLowerCase());
                                }).map(function(el) {
                                    return {
                                        y: (el.boundingArea[1] + el.boundingArea[3]) / 2,
                                        height: el.boundingArea[3] - el.boundingArea[1]
                                    };
                                });
                                // Sort orange elements by their original vertical position
                                var sortedOrangeElements = (0,_to_consumable_array/* default */.Z)(orangeElements).sort(function(a, b) {
                                    return (a.boundingArea[1] + a.boundingArea[3]) / 2 - (b.boundingArea[1] + b.boundingArea[3]) / 2;
                                });
                                var lastOrangeY = 0;
                                return sortedOrangeElements.map(function(element, index) {
                                    var description = element.description;
                                    var centerY = (element.boundingArea[1] + element.boundingArea[3]) / 2;
                                    // If this isn't the first orange circle, enforce vertical spacing
                                    if (index > 0) {
                                        var minY = lastOrangeY + VERTICAL_SPACING;
                                        if (centerY < minY) {
                                            centerY = minY;
                                        }
                                    }
                                    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                                    try {
                                        // Check for collisions with red circles
                                        for(var _iterator = redCirclePositions[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                                            var red = _step.value;
                                            if (Math.abs(centerY - red.y) < VERTICAL_SPACING) {
                                                centerY = red.y + red.height / 2 + VERTICAL_SPACING;
                                            }
                                        }
                                    } catch (err) {
                                        _didIteratorError = true;
                                        _iteratorError = err;
                                    } finally{
                                        try {
                                            if (!_iteratorNormalCompletion && _iterator.return != null) {
                                                _iterator.return();
                                            }
                                        } finally{
                                            if (_didIteratorError) {
                                                throw _iteratorError;
                                            }
                                        }
                                    }
                                    lastOrangeY = centerY;
                                    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        style: {
                                            position: "relative"
                                        },
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                onClick: function(e) {
                                                    e.stopPropagation();
                                                    //@ts-expect-error -gen
                                                    setOpenTooltip("orange-".concat(index));
                                                },
                                                style: {
                                                    position: "absolute",
                                                    top: "".concat(centerY, "px"),
                                                    left: "".concat(HORIZONTAL_CENTER, "px"),
                                                    transform: "translate(-50%, -50%)",
                                                    width: "30px",
                                                    height: "30px",
                                                    backgroundColor: "#ffa500",
                                                    borderRadius: "50%",
                                                    display: "flex",
                                                    alignItems: "center",
                                                    justifyContent: "center",
                                                    color: "white",
                                                    fontWeight: "bold",
                                                    fontSize: "20px",
                                                    cursor: "pointer",
                                                    border: "2px solid white",
                                                    boxShadow: "0 2px 4px rgba(0,0,0,0.3)",
                                                    zIndex: 15,
                                                    pointerEvents: "auto"
                                                },
                                                children: "!"
                                            }),
                                            openTooltip === "orange-".concat(index) && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                style: {
                                                    position: "absolute",
                                                    top: "".concat(centerY + 20, "px"),
                                                    left: "50%",
                                                    transform: "translateX(-50%)",
                                                    width: "calc(100% - 40px)",
                                                    maxWidth: "350px",
                                                    backgroundColor: "white",
                                                    border: "2px solid #ffa500",
                                                    color: "#333",
                                                    borderRadius: "12px",
                                                    padding: "15px",
                                                    fontSize: "16px",
                                                    lineHeight: 1.4,
                                                    zIndex: 20,
                                                    boxShadow: "0 4px 8px rgba(0,0,0,0.2)",
                                                    pointerEvents: "auto"
                                                },
                                                children: description
                                            })
                                        ]
                                    }, "mobile-orange-".concat(index));
                                });
                            }()
                        ]
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        style: {
                            position: "absolute",
                            top: 0,
                            left: 0,
                            width: "100%",
                            height: "100%",
                            transform: "scale(".concat(scaleFactor, ")"),
                            transformOrigin: "0 0"
                        },
                        children: processedElements.map(function(element, index) {
                            var assignedSlot = element.assignedSlot, boundingArea = element.boundingArea, description = element.description, type = element.type;
                            if (!assignedSlot) {
                                return null;
                            }
                            //@ts-ignore
                            var tooltipWidth = tooltipWidths[index] || 300;
                            var centerX = (boundingArea[0] + boundingArea[2]) / 2;
                            var centerY = (boundingArea[1] + boundingArea[3]) / 2;
                            var lineStartX = assignedSlot.x + tooltipWidth / 2;
                            var lineStartY = assignedSlot.y;
                            var widthHere = assignedSlot.y === 400 && assignedSlot.x === 10 ? 370 : "auto";
                            return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                children: [
                                    !(boundingArea[0] === 0 && boundingArea[1] === 0 && boundingArea[2] === 0 && boundingArea[3] === 0) && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        //@ts-expect-error - gen
                                        className: index,
                                        style: {
                                            position: "absolute",
                                            top: lineStartY,
                                            left: lineStartX,
                                            width: Math.sqrt(Math.pow(centerX - lineStartX, 2) + Math.pow(centerY - lineStartY, 2)),
                                            height: lineWidth,
                                            backgroundColor: "black",
                                            transform: "rotate(".concat(Math.atan2(centerY - lineStartY, centerX - lineStartX), "rad)"),
                                            transformOrigin: "0 0"
                                        }
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        //@ts-expect-error - gen
                                        ref: function(el) {
                                            return tooltipRefs.current[index] = el;
                                        },
                                        style: {
                                            position: "absolute",
                                            letterSpacing: "-1px",
                                            top: assignedSlot.y,
                                            left: assignedSlot.x,
                                            //      width: widthHere,//
                                            // @ts-expect-error -gen
                                            width: assignedSlot.maxWidth ? assignedSlot.maxWidth : 800,
                                            maxWidth: "1000px",
                                            backgroundColor: "white",
                                            border: "2px solid black",
                                            color: "#333",
                                            borderRadius: "40px",
                                            padding: "15px 15px 20px 25px",
                                            fontSize: "".concat(fontSize, "px"),
                                            lineHeight: 1.2,
                                            pointerEvents: "none",
                                            zIndex: 10
                                        },
                                        className: "d-none d-md-block md-d-block",
                                        children: description
                                    })
                                ]
                            }, index);
                        })
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var test_ScreenCanvas = (ScreenCanvas);

// EXTERNAL MODULE: ./node_modules/lucide-react/dist/esm/icons/triangle-alert.js
var triangle_alert = __webpack_require__(116);
// EXTERNAL MODULE: ./node_modules/lucide-react/dist/esm/icons/circle-check-big.js
var circle_check_big = __webpack_require__(9589);
// EXTERNAL MODULE: ./node_modules/lucide-react/dist/esm/icons/circle-x.js
var circle_x = __webpack_require__(1108);
// EXTERNAL MODULE: ./node_modules/react-circular-progressbar/dist/index.esm.js
var index_esm = __webpack_require__(5774);
// EXTERNAL MODULE: ./node_modules/react-circular-progressbar/dist/styles.css
var styles = __webpack_require__(6422);
// EXTERNAL MODULE: ./src/components/reuseable/KeywordList.tsx
var KeywordList = __webpack_require__(9511);
;// CONCATENATED MODULE: ./src/components/reuseable/test-Report.tsx



 // Import useEffect




//check if a string contains any of the keywords 
var containsKeywords = function(text, keywords) {
    if (!text) return false;
    return keywords.some(function(keyword) {
        return text.toLowerCase().includes(keyword.toLowerCase());
    });
};
// parse speed values like "2.4 s" into numbers
var parseSpeedValue = function(value) {
    if (!value) return 0;
    return parseFloat(value.replace(/[^0-9.]/g, "")); // Remove non-numeric characters and parse
};
//status icons 
var statusIcon = function(status) {
    if (status === undefined) return /*#__PURE__*/ (0,jsx_runtime.jsx)(triangle_alert/* default */.Z, {
        color: "orange"
    }); // Show warning for undefined
    return status ? /*#__PURE__*/ (0,jsx_runtime.jsx)(circle_check_big/* default */.Z, {
        color: "green"
    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
        className: "pe-1",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(circle_x/* default */.Z, {
            color: "red",
            size: "20",
            style: {
                marginTop: -5
            }
        })
    });
};
//@ts-ignore
var BasicSeoContent = function(param) {
    var siteData = param.siteData, hasBasicSeoFailures = param.hasBasicSeoFailures, score = param.score;
    var ref, ref1, ref2, ref3, ref4;
    var titlePass = containsKeywords(siteData === null || siteData === void 0 ? void 0 : siteData.title, (siteData === null || siteData === void 0 ? void 0 : siteData.keywords) || []);
    var metaPass = containsKeywords(siteData === null || siteData === void 0 ? void 0 : siteData.metaDescription, (siteData === null || siteData === void 0 ? void 0 : siteData.keywords) || []);
    var ogTitlePass = containsKeywords(siteData === null || siteData === void 0 ? void 0 : siteData.ogTitle, (siteData === null || siteData === void 0 ? void 0 : siteData.keywords) || []);
    var ogDescPass = containsKeywords(siteData === null || siteData === void 0 ? void 0 : siteData.ogDescription, (siteData === null || siteData === void 0 ? void 0 : siteData.keywords) || []);
    var ogPass = ogTitlePass && ogDescPass;
    var canonicalPass = !!(siteData === null || siteData === void 0 ? void 0 : siteData.canonical);
    var sitemapPass = !!(siteData === null || siteData === void 0 ? void 0 : siteData.sitemap);
    var robotsPass = !!(siteData === null || siteData === void 0 ? void 0 : (ref = siteData.robotsTxt) === null || ref === void 0 ? void 0 : ref.exists);
    var llmsPass = !!(siteData === null || siteData === void 0 ? void 0 : (ref1 = siteData.llmsTxt) === null || ref1 === void 0 ? void 0 : ref1.exists);
    var schemaMarkupPresent = !!(siteData === null || siteData === void 0 ? void 0 : (ref2 = siteData.schemaMarkup) === null || ref2 === void 0 ? void 0 : ref2.found);
    //for images, combine desktop and mobile elements
    var allImages = (0,_to_consumable_array/* default */.Z)((siteData === null || siteData === void 0 ? void 0 : (ref3 = siteData.desktop) === null || ref3 === void 0 ? void 0 : ref3.elements) || []).concat((0,_to_consumable_array/* default */.Z)((siteData === null || siteData === void 0 ? void 0 : (ref4 = siteData.mobile) === null || ref4 === void 0 ? void 0 : ref4.elements) || [])).filter(function(element) {
        return element.type === "img";
    });
    var imagesAltPass = allImages.every(function(element) {
        return element.alt && containsKeywords(element.alt, (siteData === null || siteData === void 0 ? void 0 : siteData.keywords) || []);
    });
    var filenamesPass = allImages.every(function(element) {
        return containsKeywords(element.filename, (siteData === null || siteData === void 0 ? void 0 : siteData.keywords) || []);
    });
    // Determine color based on score
    var getProgressColor = function(score) {
        if (score >= 0 && score <= 49) return "#dc3545"; // Red
        if (score >= 50 && score <= 69) return "#fd7e14"; // Orange
        if (score >= 70 && score <= 100) return "#198754"; // Green (Bootstrap 5 green)
        return "#0d6efd"; // Default blue (Bootstrap 5 blue)
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
        className: "mt-6",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                style: {
                    width: 100,
                    height: 100
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* CircularProgressbar */.Ip, {
                    value: score,
                    text: "".concat(score, "%"),
                    styles: {
                        path: {
                            stroke: getProgressColor(score)
                        },
                        text: {
                            fill: getProgressColor(score)
                        }
                    }
                })
            }),
            hasBasicSeoFailures && /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                className: "text-xl font-semibold border-b pb-2 mt-4",
                children: "Basic SEO"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(KeywordList/* default */.Z, {
                keywords: (siteData === null || siteData === void 0 ? void 0 : siteData.keywords) || []
            }),
            (siteData === null || siteData === void 0 ? void 0 : siteData.keywordPositions) && Object.entries(siteData.keywordPositions).filter(function(param) {
                var _param = (0,_sliced_to_array/* default */.Z)(param, 2), _ = _param[0], position = _param[1];
                return String(position).toLowerCase() !== "error";
            }).map(function(param) {
                var _param = (0,_sliced_to_array/* default */.Z)(param, 2), keyword = _param[0], position = _param[1];
                var isNotFound = position === -1 || position === "Not in top 100";
                return /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                    className: "mb-3",
                    children: [
                        'Your main industry keyword, "',
                        keyword,
                        '"',
                        " ",
                        isNotFound ? "is not in top 100 in Google results." : "is number " + position + " in Google results."
                    ]
                }, keyword);
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("sup", {
                className: "supIt",
                style: {
                    lineHeight: "1.25",
                    display: "block"
                },
                children: [
                    "Find out more keyword rankings and competitor data with our full ",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                        href: "#full_report",
                        children: "SEO Audit"
                    }),
                    " or ask for a free consultation about how we can help you drive more sales."
                ]
            }),
            function() {
                var failingSections = [];
                if (!llmsPass) failingSections.push(/*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "mt-3",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                            className: "text-lg font-medium",
                            children: "ChatGPT/AI"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                            children: [
                                statusIcon(llmsPass),
                                " Missing llms.txt",
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                "llms.txt is a text file that tells ChatGPT and other AI/LLM systems how to crawl, index, and interact with your website."
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            children: "Add one to enhance your appearance in ChatGPT and other AI chatbots."
                        })
                    ]
                }, "llms"));
                if (!titlePass) failingSections.push(/*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "mt-3",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                            className: "text-lg font-medium",
                            children: "Title"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            children: "The title appears in browser tabs and search results."
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                            children: [
                                statusIcon(titlePass),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                    children: "Keywords are not in the title"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                "If you don't include keywords in the title, it makes it harder for people to find your page."
                            ]
                        })
                    ]
                }, "title"));
                if (!metaPass) failingSections.push(/*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "mt-3",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                            className: "text-lg font-medium",
                            children: "Meta Description"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            children: "This is a short summary shown in search results."
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                            children: [
                                statusIcon(metaPass),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                    children: "Keywords are not in Meta Description"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                "It does not contain keywords, so people searching will probably not click on your link in Google results."
                            ]
                        })
                    ]
                }, "meta"));
                if (!ogTitlePass || !ogDescPass) failingSections.push(/*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                            className: "mt-3 text-lg font-medium",
                            children: "OG Information"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            children: "This is the information used when people share your page on social media."
                        }),
                        !ogTitlePass && /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                            children: [
                                statusIcon(ogTitlePass),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                    children: "Keywords are not in OG Title"
                                }),
                                " ",
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                "Doesn't use search keywords; this reduces visibility in social media."
                            ]
                        }),
                        !ogDescPass && /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                            children: [
                                statusIcon(ogDescPass),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                    children: "Keywords are not in OG Description"
                                }),
                                " ",
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                "Missing keywords in the description, so you won't have much engagement on shares on social media."
                            ]
                        })
                    ]
                }, "og"));
                if (!canonicalPass) failingSections.push(/*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "mt-3",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("h3", {
                            className: "text-lg font-medium",
                            children: [
                                statusIcon(canonicalPass),
                                " Canonical URL"
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            children: 'Tells search engines which version of a page is the "main" one.'
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                    children: "There is no canonical URL specified."
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                "Without it, duplicate content can confuse Google and affect rankings."
                            ]
                        })
                    ]
                }, "canonical"));
                if (!sitemapPass) failingSections.push(/*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "mt-3",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("h3", {
                            className: "text-lg font-medium",
                            children: [
                                statusIcon(sitemapPass),
                                " Sitemap"
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            children: "Help search engines navigate your site by including an up-to-date sitemap. Missing sitemap may lead to very poor Google results."
                        })
                    ]
                }, "sitemap"));
                if (!robotsPass) failingSections.push(/*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "mt-3",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("h3", {
                            className: "text-lg font-medium",
                            children: [
                                statusIcon(robotsPass),
                                " Robots.txt"
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            children: "Missing robots.txt may lead to very poor Google results."
                        })
                    ]
                }, "robots"));
                if (!imagesAltPass || !filenamesPass) failingSections.push(/*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "mt-3",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                            className: "text-lg font-medium",
                            children: "Image Alt Tags and Filenames"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                            children: [
                                !imagesAltPass && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                    children: [
                                        statusIcon(imagesAltPass),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                            children: "All Images Do Not Have Alt Tags That Contain Keywords"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                            children: "Images need explanatory text for people with disabilities. If you don't include them, Google marks your content down."
                                        })
                                    ]
                                }),
                                !filenamesPass && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                    children: [
                                        statusIcon(filenamesPass),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                            children: "All Filenames Do Not Contain Keywords"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                            children: "The actual filename of your images can contain keywords and this give you a little SEO boost."
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                }, "images"));
                if (!schemaMarkupPresent) failingSections.push(/*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "mt-3",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("h3", {
                            className: "text-lg mb-0 font-medium",
                            children: [
                                statusIcon(schemaMarkupPresent),
                                " Schema Markup"
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            children: "Special tags that help search engines understand your content better."
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                children: "Schema markup is missing or invalid."
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            children: "Missing or broken markup – rich results (like review stars or product info) won't show."
                        })
                    ]
                }, "schema"));
                // Show only the first 3 failing sections
                var displayedSections = failingSections;
                // const displayedSections = failingSections.slice(0, 3);
                return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                    children: [
                        displayedSections,
                        function() {
                            var ref;
                            var kdObj = (siteData === null || siteData === void 0 ? void 0 : (ref = siteData.keywordDensity) === null || ref === void 0 ? void 0 : ref.keyword_density) || {};
                            var kdValues = Object.values(kdObj);
                            //@ts-expect-error - gen
                            var sumDensity = kdValues.reduce(function(acc, val) {
                                return acc + (val || 0);
                            }, 0);
                            //@ts-expect-error - gen
                            var averageDensity = kdValues.length ? sumDensity / kdValues.length : 0;
                            var keywordDensityFail = averageDensity < 3 || averageDensity >= 4;
                            var keywordDensityMessage = "";
                            if (averageDensity < 3) {
                                keywordDensityMessage = "There are not enough mentions of your keywords on your homepage.";
                            } else if (averageDensity >= 4) {
                                keywordDensityMessage = "There is keyword stuffing in your website.";
                            }
                            if (!keywordDensityFail) return null;
                            return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "mt-3",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("h3", {
                                        className: "text-lg font-medium",
                                        children: [
                                            statusIcon(false),
                                            "Keyword Density"
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        children: keywordDensityMessage
                                    })
                                ]
                            });
                        }()
                    ]
                });
            }()
        ]
    });
};
var BASIC_SEO_WEIGHTS = {
    title: 9,
    metaDescription: 9,
    ogTitle: 3,
    ogDescription: 3,
    canonical: 3,
    sitemap: 9,
    robotsTxt: 3,
    llmsTxt: 5,
    imagesAlt: 10,
    filenames: 9,
    keywordDensity: 9,
    schemaMarkup: 3
};
//@ts-ignore
var calculateBasicSeoScore = function(siteData) {
    var ref, ref1, ref2, ref3, ref4, ref5;
    var score = 0;
    if (containsKeywords(siteData === null || siteData === void 0 ? void 0 : siteData.title, (siteData === null || siteData === void 0 ? void 0 : siteData.keywords) || [])) score += BASIC_SEO_WEIGHTS.title;
    if (containsKeywords(siteData === null || siteData === void 0 ? void 0 : siteData.metaDescription, (siteData === null || siteData === void 0 ? void 0 : siteData.keywords) || [])) score += BASIC_SEO_WEIGHTS.metaDescription;
    if (containsKeywords(siteData === null || siteData === void 0 ? void 0 : siteData.ogTitle, (siteData === null || siteData === void 0 ? void 0 : siteData.keywords) || []) && containsKeywords(siteData === null || siteData === void 0 ? void 0 : siteData.ogDescription, (siteData === null || siteData === void 0 ? void 0 : siteData.keywords) || [])) score += BASIC_SEO_WEIGHTS.ogTitle + BASIC_SEO_WEIGHTS.ogDescription;
    if (siteData === null || siteData === void 0 ? void 0 : siteData.canonical) score += BASIC_SEO_WEIGHTS.canonical;
    if (siteData === null || siteData === void 0 ? void 0 : siteData.sitemap) score += BASIC_SEO_WEIGHTS.sitemap;
    if (siteData === null || siteData === void 0 ? void 0 : (ref = siteData.robotsTxt) === null || ref === void 0 ? void 0 : ref.exists) score += BASIC_SEO_WEIGHTS.robotsTxt;
    if (siteData === null || siteData === void 0 ? void 0 : (ref1 = siteData.llmsTxt) === null || ref1 === void 0 ? void 0 : ref1.exists) score += BASIC_SEO_WEIGHTS.llmsTxt;
    //scoring for images and keyword density
    var allImages = (0,_to_consumable_array/* default */.Z)((siteData === null || siteData === void 0 ? void 0 : (ref2 = siteData.desktop) === null || ref2 === void 0 ? void 0 : ref2.elements) || []).concat((0,_to_consumable_array/* default */.Z)((siteData === null || siteData === void 0 ? void 0 : (ref3 = siteData.mobile) === null || ref3 === void 0 ? void 0 : ref3.elements) || [])).filter(function(element) {
        return element.type === "img";
    });
    var imagesAltPass = allImages.every(function(element) {
        return element.alt && containsKeywords(element.alt, (siteData === null || siteData === void 0 ? void 0 : siteData.keywords) || []);
    });
    var filenamesPass = allImages.every(function(element) {
        return containsKeywords(element.filename, (siteData === null || siteData === void 0 ? void 0 : siteData.keywords) || []);
    });
    if (imagesAltPass) score += BASIC_SEO_WEIGHTS.imagesAlt;
    if (filenamesPass) score += BASIC_SEO_WEIGHTS.filenames;
    var kdObj = (siteData === null || siteData === void 0 ? void 0 : (ref4 = siteData.keywordDensity) === null || ref4 === void 0 ? void 0 : ref4.keyword_density) || {};
    var kdValues = Object.values(kdObj);
    //@ts-ignore
    var sumDensity = kdValues.reduce(function(acc, val) {
        return acc + val;
    }, 0);
    //@ts-ignore
    var averageDensity = kdValues.length ? sumDensity / kdValues.length : 0;
    if (averageDensity >= 3 && averageDensity < 4) score += BASIC_SEO_WEIGHTS.keywordDensity;
    // SCHEMA MARKUP: use .found not .status
    if (siteData === null || siteData === void 0 ? void 0 : (ref5 = siteData.schemaMarkup) === null || ref5 === void 0 ? void 0 : ref5.found) score += BASIC_SEO_WEIGHTS.schemaMarkup;
    //the total possible score
    var totalWeight = Object.values(BASIC_SEO_WEIGHTS).reduce(function(acc, weight) {
        return acc + weight;
    }, 0);
    return Math.round(score / totalWeight * 100);
};
var PerformanceContent = function(param) {
    var //@ts-expect-error - gen
    siteData = param.siteData, //@ts-expect-error - gen
    pageSpeedData = param.pageSpeedData, //@ts-expect-error - gen
    hasPerformanceFailure = param.hasPerformanceFailure, //@ts-expect-error - gen
    score = param.score, //@ts-expect-error - gen
    performValues = param.performValues, //@ts-expect-error - gen
    performanceView = param.performanceView, //@ts-expect-error - gen
    setPerformanceView = param.setPerformanceView;
    var ref, ref1;
    var parseSizeValue = function(//@ts-expect-error - gen
    // 
    str) {
        if (!str) return 0;
        var match = str.match(/\d+/);
        return match ? parseInt(match[0]) : 0;
    };
    // Check individual metrics - these are just INDICATORS, not for scoring
    var speedIndexSlow = parseSpeedValue(pageSpeedData.speedIndex) > performValues.speed;
    var fcpSlow = parseSpeedValue(pageSpeedData.firstContentfulPaint) > performValues.fcp;
    var interactiveSlow = parseSpeedValue(pageSpeedData.interactive) > performValues.interact;
    var hasResponsiveImageIssues = pageSpeedData.usesResponsiveImages !== "N/A" && pageSpeedData.usesResponsiveImages.includes("savings");
    var hasUnminifiedJS = pageSpeedData.unminifiedJavaScript !== "N/A" && pageSpeedData.unminifiedJavaScript.includes("savings");
    var hasUnminifiedCSS = pageSpeedData.unminifiedCSS !== "N/A" && pageSpeedData.unminifiedCSS.includes("savings");
    var hasRenderBlocking = pageSpeedData.renderBlockingResources !== "N/A" && pageSpeedData.renderBlockingResources.includes("savings");
    var byteWeightHigh = parseSizeValue(pageSpeedData.totalByteWeight) > 2000;
    var tooManyRequests = pageSpeedData.networkRequests !== "N/A" && parseInt(pageSpeedData.networkRequests) > 100;
    var hasRedirects = pageSpeedData.redirects !== "N/A" && !pageSpeedData.redirects.includes("0 ms");
    var contentLengthIssue = (siteData === null || siteData === void 0 ? void 0 : (ref = siteData.contentLength) === null || ref === void 0 ? void 0 : ref.status) === false;
    var headingHierarchyIssue = !(siteData === null || siteData === void 0 ? void 0 : (ref1 = siteData.headingHierarchy) === null || ref1 === void 0 ? void 0 : ref1.status);
    var failingPerformanceSections = [];
    // Only show sections that actually have issues
    if (speedIndexSlow || fcpSlow || interactiveSlow) {
        failingPerformanceSections.push(/*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "mt-3",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                    className: "text-lg font-medium",
                    children: "Page Speed Issues"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    children: [
                        speedIndexSlow && /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                            children: [
                                statusIcon(false),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                    children: "Speed Index:"
                                }),
                                " ",
                                pageSpeedData.speedIndex,
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                "Your page loads slowly for visitors."
                            ]
                        }),
                        fcpSlow && /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                            children: [
                                statusIcon(false),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                    children: "First Content Paint:"
                                }),
                                " ",
                                pageSpeedData.firstContentfulPaint,
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                "First content takes too long to appear."
                            ]
                        }),
                        interactiveSlow && /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                            children: [
                                statusIcon(false),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                    children: "Time to Interactive:"
                                }),
                                " ",
                                pageSpeedData.interactive,
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                "Visitors have to wait before they can interact with your site."
                            ]
                        })
                    ]
                })
            ]
        }, "pageSpeed"));
    }
    if (hasResponsiveImageIssues || hasUnminifiedJS || hasUnminifiedCSS || hasRenderBlocking) {
        failingPerformanceSections.push(/*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "mt-3",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                    className: "text-lg font-medium",
                    children: "Resource Optimization"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    children: [
                        hasResponsiveImageIssues && /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                            children: [
                                statusIcon(false),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                    children: "Responsive Images:"
                                }),
                                " ",
                                pageSpeedData.usesResponsiveImages,
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                "Images aren't optimized for different screen sizes."
                            ]
                        }),
                        hasUnminifiedJS && /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                            children: [
                                statusIcon(false),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                    children: "Unminified JavaScript:"
                                }),
                                " ",
                                pageSpeedData.unminifiedJavaScript,
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                "JavaScript files should be compressed."
                            ]
                        }),
                        hasUnminifiedCSS && /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                            children: [
                                statusIcon(false),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                    children: "Unminified CSS:"
                                }),
                                " ",
                                pageSpeedData.unminifiedCSS,
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                "CSS files should be compressed."
                            ]
                        }),
                        hasRenderBlocking && /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                            children: [
                                statusIcon(false),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                    children: "Render Blocking Resources:"
                                }),
                                " ",
                                pageSpeedData.renderBlockingResources,
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                "These delay your homepage from showing."
                            ]
                        })
                    ]
                })
            ]
        }, "resourceOpt"));
    }
    if (byteWeightHigh || tooManyRequests || hasRedirects) {
        failingPerformanceSections.push(/*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "mt-3",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                    className: "text-lg font-medium",
                    children: "Content Delivery"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    children: [
                        byteWeightHigh && /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                            children: [
                                statusIcon(false),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                    children: "Total Page Size:"
                                }),
                                " ",
                                pageSpeedData.totalByteWeight,
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                "Page is too heavy - should be under 2MB."
                            ]
                        }),
                        tooManyRequests && /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                            children: [
                                statusIcon(false),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                    children: "Network Requests:"
                                }),
                                " ",
                                pageSpeedData.networkRequests,
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                "Too many files being loaded - aim for under 100."
                            ]
                        }),
                        hasRedirects && /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                            children: [
                                statusIcon(false),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                    children: "Redirects:"
                                }),
                                " ",
                                pageSpeedData.redirects,
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                "Redirects slow down your site."
                            ]
                        })
                    ]
                })
            ]
        }, "contentDelivery"));
    }
    if (contentLengthIssue || headingHierarchyIssue) {
        failingPerformanceSections.push(/*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "mt-3",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                    className: "text-lg font-medium",
                    children: "Other Issues"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    children: [
                        contentLengthIssue && /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                            children: [
                                statusIcon(false),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                    children: "Content Length:"
                                }),
                                " ",
                                siteData.contentLength.message,
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                "Too little content may hurt SEO."
                            ]
                        }),
                        headingHierarchyIssue && /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                            children: [
                                statusIcon(false),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                    children: "Heading Hierarchy:"
                                }),
                                " Improper structure",
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                "Headings should follow logical order (H1, H2, H3)."
                            ]
                        })
                    ]
                })
            ]
        }, "other"));
    }
    var getProgressColor = function(score) {
        if (score >= 0 && score <= 49) return "#dc3545";
        if (score >= 50 && score <= 69) return "#fd7e14";
        if (score >= 70 && score <= 100) return "#198754";
        return "#0d6efd";
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
        className: "mt-6",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                style: {
                    width: 100,
                    height: 100
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* CircularProgressbar */.Ip, {
                    value: score,
                    text: "".concat(score, "%"),
                    styles: {
                        path: {
                            stroke: getProgressColor(score)
                        },
                        text: {
                            fill: getProgressColor(score)
                        }
                    }
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                className: "text-xl font-semibold border-b pb-2 mt-4",
                children: "Performance"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                className: "text-sm mb-3",
                children: "Score from Google PageSpeed Insights"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "d-flex justify-content-center mb-3",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "btn-group",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                            className: "btn ".concat(performanceView === "desktop" ? "btn-primary" : "btn-outline-primary"),
                            onClick: function() {
                                return setPerformanceView("desktop");
                            },
                            children: "Desktop"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                            className: "btn ".concat(performanceView === "mobile" ? "btn-primary" : "btn-outline-primary"),
                            onClick: function() {
                                return setPerformanceView("mobile");
                            },
                            children: "Mobile"
                        })
                    ]
                })
            }),
            failingPerformanceSections.length > 0 ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: "mb-3",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                            children: "Issues detected:"
                        })
                    }),
                    failingPerformanceSections
                ]
            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                className: "text-success",
                children: "✓ No major performance issues detected!"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "mt-4 p-3",
                style: {
                    backgroundColor: "#f8f9fa",
                    borderLeft: "4px solid #0d6efd"
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: "mb-2",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                            children: "Google PageSpeed also tests:"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                        className: "mb-2",
                        style: {
                            fontSize: "0.9em",
                            lineHeight: "1.6"
                        },
                        children: [
                            !hasResponsiveImageIssues && /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                        children: "Image optimization:"
                                    }),
                                    " Modern formats (WebP), proper sizing, lazy loading"
                                ]
                            }),
                            !hasUnminifiedJS && !hasUnminifiedCSS && !hasRenderBlocking && /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                        children: "Code optimization:"
                                    }),
                                    " Minified JavaScript/CSS, eliminating render-blocking"
                                ]
                            }),
                            !tooManyRequests && /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                        children: "Request efficiency:"
                                    }),
                                    " Reducing HTTP requests, combining files"
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                        children: "Server performance:"
                                    }),
                                    " Hosting speed, response times, CDN usage"
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                        children: "Browser caching:"
                                    }),
                                    " Storing assets to reduce repeat downloads"
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                        children: "Third-party scripts:"
                                    }),
                                    " Impact from tracking, ads, social plugins"
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                        className: "mb-0",
                        style: {
                            fontSize: "0.9em"
                        },
                        children: [
                            "Our ",
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                href: "#full_report",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                    children: "full SEO audit"
                                })
                            }),
                            " analyzes all ",
                            failingPerformanceSections.length > 0 ? "these factors" : "performance factors",
                            " in detail with specific fixes to improve your score."
                        ]
                    })
                ]
            })
        ]
    });
};
//Report component
//@ts-expect-error gen
var Report = function(param) {
    var siteData = param.siteData, domain = param.domain, pageSpeed = param.pageSpeed, pageSpeedMobile = param.pageSpeedMobile;
    var ref = (0,react.useState)(false), performanceDataLoaded = ref[0], setPerformanceDataLoaded = ref[1];
    var ref1 = (0,react.useState)("mobile"), performanceView = ref1[0], setPerformanceView = ref1[1];
    (0,react.useEffect)(function() {
        console.log(domain);
    }, [
        siteData,
        domain
    ]);
    (0,react.useEffect)(function() {
        if (pageSpeed || pageSpeedMobile) {
            if (pageSpeed) pageSpeed.device = "desktop";
            if (pageSpeedMobile) pageSpeedMobile.device = "mobile";
            setPerformanceDataLoaded(true);
        } else {
            setPerformanceDataLoaded(false);
        }
    }, [
        pageSpeed,
        pageSpeedMobile
    ]);
    var basicSeoScore = calculateBasicSeoScore(siteData);
    var performanceScore = performanceDataLoaded && pageSpeed ? pageSpeed.performanceScore : 0;
    var performanceScoreMobile = performanceDataLoaded && pageSpeedMobile ? pageSpeedMobile.performanceScore : 0;
    var hasBasicSeoFailures = basicSeoScore < 100;
    var hasPerformanceFailureDesktop = performanceDataLoaded && pageSpeed && performanceScore < 100;
    var hasPerformanceFailureMobile = performanceDataLoaded && pageSpeedMobile && performanceScoreMobile < 100;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "container",
        style: {
            maxWidth: 1000
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                className: "display-4 mt-10 pb-3",
                style: {
                    textAlign: "center"
                },
                children: "Report"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                className: "pb-3",
                style: {
                    textAlign: "center",
                    display: "block",
                    margin: "0 auto"
                },
                children: "Here is an initial analysis of your homepage landing screen. This shows issues with your Basic SEO and Google's measurement of the site's performance.  "
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                className: "pb-3",
                style: {
                    textAlign: "center",
                    display: "block",
                    margin: "0 auto"
                },
                children: [
                    "Bear in mind that there are ",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("em", {
                        children: "lots of other factors that affect ranking"
                    }),
                    ", like getting ",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                        children: "Good Quality Backlinks"
                    }),
                    " and having ",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                        children: "Rich Content"
                    }),
                    " throughout your site. We prioritise only tasks that will make your site succeed and convert more customers. So ",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                        href: "#full_report",
                        children: "get in touch"
                    }),
                    " if you'd like to discuss your SEO and start improving your exposure today."
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "row g-10 pb-10",
                children: [
                    hasBasicSeoFailures && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "col-md-6",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(BasicSeoContent, {
                            siteData: siteData,
                            hasBasicSeoFailures: hasBasicSeoFailures,
                            score: basicSeoScore
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "col-md-6",
                        children: !performanceDataLoaded ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "loading-placeholder",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
                                className: "mt-6",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        style: {
                                            width: 100,
                                            height: 100
                                        },
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* CircularProgressbar */.Ip, {
                                            value: 0,
                                            text: "0%"
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                        className: "text-xl font-semibold border-b pb-2 mt-4",
                                        children: "Performance Loading.."
                                    })
                                ]
                            })
                        }) : (hasPerformanceFailureDesktop || hasPerformanceFailureMobile) && /*#__PURE__*/ (0,jsx_runtime.jsx)(PerformanceContent, {
                            siteData: siteData,
                            pageSpeedData: performanceView === "desktop" ? pageSpeed : pageSpeedMobile,
                            hasPerformanceFailure: performanceView === "desktop" ? hasPerformanceFailureDesktop : hasPerformanceFailureMobile,
                            score: performanceView === "desktop" ? performanceScore : performanceScoreMobile,
                            performValues: performanceView === "desktop" ? {
                                speed: 2,
                                fcp: 2,
                                interact: 3
                            } : {
                                speed: 3,
                                fcp: 3,
                                interact: 4
                            },
                            performanceView: performanceView,
                            setPerformanceView: setPerformanceView
                        })
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var test_Report = (Report);

// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ./src/components/blocks/testimonial/index.ts + 29 modules
var testimonial = __webpack_require__(659);
// EXTERNAL MODULE: ./src/components/blocks/portfolio/index.ts + 25 modules
var portfolio = __webpack_require__(362);
// EXTERNAL MODULE: ./src/components/common/SEO.tsx
var SEO = __webpack_require__(2034);
// EXTERNAL MODULE: ./src/data/keywords.ts
var data_keywords = __webpack_require__(4870);
// EXTERNAL MODULE: ./src/components/blocks/footer/index.ts + 21 modules
var footer = __webpack_require__(7702);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(1664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
;// CONCATENATED MODULE: ./src/components/common/ContactFormOnlyChaka4.tsx
/* provided dependency */ var ContactFormOnlyChaka4_process = __webpack_require__(4155);








 // or you can use fetch

//@ts-ignore
var ContactFormOnlyChaka4 = function(param) {
    var siteKey = param.siteKey, _position = param.position, position = _position === void 0 ? "left" : _position;
    var router = (0,next_router.useRouter)();
    var visitor = router.query.visitor; // Extract the `visitor` query parameter
    var ref = (0,react.useState)({
        name: "",
        surname: "",
        email: "",
        department: "",
        message: ""
    }), formData = ref[0], setFormData = ref[1];
    var hasSentMessage = (0,react.useRef)(false); // ✅ Persist across re-renders
    (0,react.useEffect)(function() {
        // console.log("Telegram Bot Token:", process.env.NEXT_PUBLIC_CHAK);
        var sendTelegramMessage = function() {
            var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
                var telegramBotToken, telegramChannelId, url, message, response;
                return runtime_default().wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            if (!(!siteKey || siteKey === "nodomain" || hasSentMessage.current)) {
                                _ctx.next = 2;
                                break;
                            }
                            return _ctx.abrupt("return");
                        case 2:
                            hasSentMessage.current = true;
                            telegramBotToken = ContactFormOnlyChaka4_process.env.NEXT_PUBLIC_CHAK;
                            telegramChannelId = "7072776421";
                            if (!(!telegramBotToken || !telegramChannelId)) {
                                _ctx.next = 8;
                                break;
                            }
                            console.error("Telegram bot token or channel ID is missing");
                            return _ctx.abrupt("return");
                        case 8:
                            url = "https://api.telegram.org/bot".concat(telegramBotToken, "/sendMessage");
                            message = "\uD83D\uDCE5 Domain: ".concat(siteKey, " CONTACTED US!\nSimple click, no booking.");
                            _ctx.prev = 10;
                            _ctx.next = 13;
                            return axios/* default.post */.Z.post(url, {
                                chat_id: telegramChannelId,
                                text: message
                            });
                        case 13:
                            response = _ctx.sent;
                            if (response.status === 200) {
                                console.log("Message sent to Telegram successfully");
                            } else {
                                console.error("Failed to send message to Telegram");
                            }
                            _ctx.next = 20;
                            break;
                        case 17:
                            _ctx.prev = 17;
                            _ctx.t0 = _ctx["catch"](10);
                            console.error("Error sending message:", _ctx.t0);
                        case 20:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee, null, [
                    [
                        10,
                        17
                    ]
                ]);
            }));
            return function sendTelegramMessage() {
                return _ref.apply(this, arguments);
            };
        }();
        sendTelegramMessage();
    }, [
        siteKey
    ]); // ✅ Runs only when siteKey changes
    var handleChange = function(e) {
        var _target = e.target, name = _target.name, value = _target.value;
        setFormData(function(prev) {
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, prev), (0,_define_property/* default */.Z)({}, name, value));
        });
    };
    var handleSubmit = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(e) {
            var payload, response;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        e.preventDefault();
                        payload = Object.fromEntries(new FormData(e.target));
                        payload.source = payload["form-name"] || "Website form";
                        delete payload["bot-field"];
                        _ctx.prev = 4;
                        _ctx.next = 7;
                        return axios/* default.post */.Z.post("/api/submit-form", payload);
                    case 7:
                        response = _ctx.sent;
                        if (response.status === 200) {
                            router.push("/thanks");
                        } else {
                            console.error("Failed to send message");
                        }
                        _ctx.next = 14;
                        break;
                    case 11:
                        _ctx.prev = 11;
                        _ctx.t0 = _ctx["catch"](4);
                        console.error("Error sending message:", _ctx.t0);
                    case 14:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    4,
                    11
                ]
            ]);
        }));
        return function handleSubmit(e) {
            return _ref.apply(this, arguments);
        };
    }();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                className: "display-4 mb-3 text-center",
                children: "Free Consultation"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                children: "Book a free SEO consultation with our team to see we can help you with your business goals. "
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                children: [
                    "Ask about our comprehensive SEO audit or our ",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                        href: "/pricing",
                        children: "3-month optimisation packages"
                    }),
                    ", which includes a full audit, ongoing strategy, and hands-on improvements - everything you need to unlock your site’s full potential. "
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("form", {
                name: "Consultation",
                method: "post",
                onSubmit: handleSubmit,
                className: "px-3 pb-10",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                        type: "hidden",
                        name: "form-name",
                        value: "Consultation"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: "d-none",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                name: "bot-field"
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "row gx-4",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "col-md-6",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "form-floating mb-4",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                            required: true,
                                            type: "text",
                                            name: "name",
                                            id: "name",
                                            placeholder: "Jane",
                                            className: "form-control",
                                            value: formData.name,
                                            onChange: handleChange
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                                            htmlFor: "name",
                                            children: "First Name *"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "valid-feedback",
                                            children: " Looks good! "
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "invalid-feedback",
                                            children: " Please enter your first name. "
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "col-md-6",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "form-floating mb-4",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                            required: true,
                                            type: "text",
                                            name: "surname",
                                            placeholder: "Doe",
                                            id: "surname",
                                            className: "form-control",
                                            value: formData.surname,
                                            onChange: handleChange
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                                            htmlFor: "form_lastname",
                                            children: "Last Name *"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "valid-feedback",
                                            children: " Looks good! "
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "invalid-feedback",
                                            children: " Please enter your last name. "
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "col-md-6",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "form-floating mb-4",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                            required: true,
                                            type: "email",
                                            name: "email",
                                            id: "form_email",
                                            className: "form-control",
                                            placeholder: "jane.doe@example.com",
                                            value: formData.email,
                                            onChange: handleChange
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                                            htmlFor: "form_email",
                                            children: "Email *"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "valid-feedback",
                                            children: " Looks good! "
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "invalid-feedback",
                                            children: " Please provide a valid email address. "
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "col-md-6",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "form-select-wrapper mb-4",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("select", {
                                            className: "form-select",
                                            id: "form-select",
                                            name: "department",
                                            required: true,
                                            value: formData.department,
                                            onChange: handleChange,
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
                                                    disabled: true,
                                                    value: "",
                                                    children: "Subject of enquiry"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
                                                    value: "freeconsultation",
                                                    children: "Free Consultation"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
                                                    value: "SEOAudit",
                                                    children: "SEO Audit"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
                                                    value: "SEOPlan",
                                                    children: "SEO Package"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "valid-feedback",
                                            children: " Looks good! "
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "invalid-feedback",
                                            children: " Please select a subject. "
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "col-12",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "form-floating mb-4",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("textarea", {
                                            required: true,
                                            name: "message",
                                            id: "form_message",
                                            className: "form-control",
                                            placeholder: "Your message",
                                            style: {
                                                height: 150
                                            },
                                            value: formData.message,
                                            onChange: handleChange
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                                            htmlFor: "form_message",
                                            children: "Message *"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "valid-feedback",
                                            children: " Looks good! "
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "invalid-feedback",
                                            children: " Please enter your message. "
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "col-12 text-center",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                        type: "submit",
                                        value: "Send message",
                                        className: "btn btn-primary rounded-pill btn-send mb-3"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                        className: "text-muted mx-auto",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                                children: "*"
                                            }),
                                            " These fields are required."
                                        ]
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var common_ContactFormOnlyChaka4 = (ContactFormOnlyChaka4);

;// CONCATENATED MODULE: ./pages/test-your-website.tsx





















"use client";
var LocalDI = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 4305).then(__webpack_require__.bind(__webpack_require__, 4890));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(4890)
            ];
        }
    },
    ssr: false
});
var InternationalDI = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 596).then(__webpack_require__.bind(__webpack_require__, 7858));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(7858)
            ];
        }
    },
    ssr: false
});
var details = {
    pageName: "SEOptimist Agency London",
    categories: "seo, web design",
    description: "Transparent, affordable and effective technical SEO services in London for professionals, agencies and enterprise.",
    parentDirectories: ""
};
var WebsiteComponent = function() {
    var createCompletionParticles = function createCompletionParticles() {
        var container = particlesRef.current;
        if (!container) return;
        var centerX = window.innerWidth / 2;
        var centerY = window.innerHeight / 2;
        for(var i = 0; i < 50; i++){
            var particle = document.createElement("div");
            particle.classList.add("particle");
            var size = Math.random() * 5 + 2;
            var colors = [
                "#5d7cff",
                "#8e54e9",
                "#ff6b9c",
                "#ffd166",
                "#5dff9d"
            ];
            var color = colors[Math.floor(Math.random() * colors.length)];
            Object.assign(particle.style, {
                width: "".concat(size, "px"),
                height: "".concat(size, "px"),
                background: color,
                borderRadius: "50%",
                left: "".concat(centerX, "px"),
                top: "".concat(centerY, "px"),
                opacity: "1",
                boxShadow: "0 0 10px ".concat(color)
            });
            container.appendChild(particle);
            var angle = Math.random() * Math.PI * 2;
            var speed = 1 + Math.random() * 3;
            var vx = Math.cos(angle) * speed;
            var vy = Math.sin(angle) * speed;
            var x = centerX;
            var y = centerY;
            var opacity = 1;
            var animate = function() {
                x += vx;
                y += vy;
                opacity -= 0.02;
                Object.assign(particle.style, {
                    left: "".concat(x, "px"),
                    top: "".concat(y, "px"),
                    opacity: "".concat(opacity)
                });
                if (opacity > 0) {
                    requestAnimationFrame(animate);
                } else {
                    particle.remove();
                }
            };
            requestAnimationFrame(animate);
        }
    };
    // @ts-expect-error - gen
    var bgColor = screen_canvas_config/* config.bgColor */.v.bgColor, screenshotWidth = screen_canvas_config/* config.screenshotWidth */.v.screenshotWidth, screenshotHeight = screen_canvas_config/* config.screenshotHeight */.v.screenshotHeight, PADDING = screen_canvas_config/* config.PADDING */.v.PADDING, extraVerticalPadding = screen_canvas_config/* config.extraVerticalPadding */.v.extraVerticalPadding, industrySector = screen_canvas_config/* config.industrySector */.v.industrySector;
    (0,useLogVisitor/* default */.Z)();
    var router = (0,next_router.useRouter)();
    var ref = (0,react.useState)(""), url = ref[0], setUrl = ref[1];
    var ref1 = (0,react.useState)(""), keywords = ref1[0], setKeywords = ref1[1];
    var ref2 = (0,react.useState)(34), fontSize = ref2[0], setFontSize = ref2[1];
    var ref3 = (0,react.useState)(null), siteData = ref3[0], setSiteData = ref3[1];
    var ref4 = (0,react.useState)(null), pageSpeedData = ref4[0], setPageSpeedData = ref4[1];
    var ref5 = (0,react.useState)(null), pageSpeedDataMobile = ref5[0], setPageSpeedDataMobile = ref5[1];
    var ref6 = (0,react.useState)(false), loading = ref6[0], setLoading = ref6[1];
    var ref7 = (0,react.useState)(null), error = ref7[0], setError = ref7[1];
    var ref8 = (0,react.useState)(true), showForm = ref8[0], setShowForm = ref8[1];
    var imageRef = (0,react.useRef)(null);
    var ref9 = (0,react.useState)(""), industry = ref9[0], setIndustry = ref9[1];
    var ref10 = (0,react.useState)(""), currentMessage = ref10[0], setCurrentMessage = ref10[1];
    var ref11 = (0,react.useState)(false), showReport = ref11[0], setShowReport = ref11[1];
    var particlesRef = (0,react.useRef)(null);
    var ref12 = (0,react.useState)({
        siteData: false,
        pageSpeed: false,
        pageSpeedMobile: false
    }), dataLoaded = ref12[0], setDataLoaded = ref12[1];
    (0,react.useEffect)(function() {
        var styleId = "custom-inline-style";
        var particlesStyleId = "particles-style";
        // Store original styles before modifying
        var originalBodyStyles = {
            background: document.body.style.background,
            backgroundAttachment: document.body.style.backgroundAttachment
        };
        var navElements = document.querySelectorAll("nav");
        var originalNavStyles = Array.from(navElements).map(function(nav) {
            return {
                element: nav,
                background: nav.style.background
            };
        });
        // Prevent duplicate styles
        if (!document.getElementById(styleId)) {
            var style = document.createElement("style");
            style.id = styleId;
            style.textContent = "\n.home.bg-soft-primary .navbar.transparent.navbar-light {\nbackground: transparent\n            }                    \n                    body {\n                        min-height: 100%;\n                        background: linear-gradient(135deg, #0f0c29, #302b63, #24243e);\n                        background-attachment: fixed;\n                         line-height: 1.6;\n                    } \n \n\n          \n                    .subtitle {\n                        font-size: 1.1rem;\n                        color: #a0b8ff;\n                        max-width: 600px;\n                        margin: 0 auto;\n                    }\n\n                    .cardy {\n                        backdrop-filter: blur(10px);\n                        border-radius: 15px;\n                        padding: 2rem;\n                        box-shadow: 0 10px 30px rgba(0, 0, 0, 0.3);\n                        border: 1px solid rgba(100, 120, 255, 0.2);\n                        margin-bottom: 2rem;\n                    }\n\n                    .form-group {\n                        margin-bottom: 1.5rem;\n                    }\n \n                    input, select {\n                        width: 100%;\n                        padding: 12px 15px;\n                        border-radius: 8px;\n                        border: 1px solid rgba(100, 120, 255, 0.3);\n                        background: rgba(10, 12, 30, 0.6);\n                        color: #fff;\n                        font-size: 1rem;\n                        transition: all 0.3s ease;\n                    }\n\n                    input:focus, select:focus {\n                        outline: none;\n                        border-color: #5d7cff;\n                        box-shadow: 0 0 0 2px rgba(93, 124, 255, 0.3);\n                    }\n\n                    .submit-btn {\n                        display: block;\n                        width: 100%;\n                        padding: 14px;\n                        background: linear-gradient(to right, #5d7cff, #8e54e9);\n                        border: none;\n                        border-radius: 8px;\n                        color: white;\n                        font-size: 1.1rem;\n                        font-weight: 600;\n                        cursor: pointer;\n                        transition: all 0.3s ease;\n                        position: relative;\n                        overflow: hidden;\n                        box-shadow: 0 5px 15px rgba(93, 124, 255, 0.4);\n                    }\n\n                    .submit-btn:hover {\n                        transform: translateY(-2px);\n                        box-shadow: 0 8px 20px rgba(93, 124, 255, 0.6);\n                    }\n\n                    .submit-btn:active {\n                        transform: translateY(1px);\n                    }\n\n                    .submit-btn::after {\n                        content: '';\n                        position: absolute;\n                        top: -50%;\n                        left: -50%;\n                        width: 200%;\n                        height: 200%;\n                        background: rgba(255, 255, 255, 0.1);\n                        transform: rotate(30deg);\n                        transition: all 0.6s ease;\n                    }\n\n                    .submit-btn:hover::after {\n                        transform: rotate(30deg) translate(20%, 20%);\n                    }\n\n                    .loading-container {\n                        display: none;\n                        text-align: center;\n                        padding: 2rem;\n                        min-height: 200px;\n                        position: relative;\n                    }\n\n                    .loading-messages {\n                        margin-top: 1.5rem;\n                        min-height: 60px;\n                    }\n\n                    .loading-message {\n                        font-size:1rem;\n                        color: #a0b8ff;\n                        margin: 1rem 0;\n                        opacity: 0;\n                        position: absolute;\n                        width: 100%;\n                        left: 0;\n                        transition: opacity 0.5s ease;\n                    }\n\n                    .loading-message.active {\n                        opacity: 1;\n                    }\n\n                    .progress-container {\n                        width: 100%;\n                        height: 20px;\n                        background: rgba(10, 12, 30, 0.6);\n                        border-radius: 10px;\n                        margin: 2rem 0;\n                        overflow: hidden;\n                        position: relative;\n                        border: 1px solid rgba(100, 120, 255, 0.2);\n                    }\n\n                    .progress-fill {\n                        height: 100%;\n                        width: 0%;\n                        border-radius: 10px;\n                        background: linear-gradient(90deg, #5d7cff, #8e54e9, #ff6b9c, #ffd166);\n                        transition: width 0.5s ease;\n                        position: relative;\n                        overflow: hidden;\n                    }\n\n                    .progress-fill::after {\n                        content: '';\n                        position: absolute;\n                        top: 0;\n                        left: 0;\n                        right: 0;\n                        bottom: 0;\n                        background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.2), transparent);\n                        animation: shimmer 2s infinite;\n                    }\n\n                    @keyframes shimmer {\n                        0% { transform: translateX(-100%); }\n                        100% { transform: translateX(100%); }\n                    }\n\n                    .particles-container {\n                        position: fixed;\n                        top: 0;\n                        left: 0;\n                        width: 100%;\n                        height: 100%;\n                        z-index: 1;\n                        overflow: hidden;\n                    }\n\n                    .particle {\n                        position: absolute;\n                        border-radius: 50%;\n                        background: rgba(255, 255, 255, 0.6);\n                        opacity: 0;\n                    }\n \n                ";
            document.head.appendChild(style);
        }
        // Cleanup: remove style if present
        // Cleanup function
        return function() {
            // Remove injected styles
            var injectedStyles = [
                document.getElementById(styleId),
                document.getElementById(particlesStyleId)
            ].filter(Boolean);
            injectedStyles.forEach(function(style) {
                return style === null || style === void 0 ? void 0 : style.remove();
            });
            // Restore original body styles
            document.body.style.background = originalBodyStyles.background;
            document.body.style.backgroundAttachment = originalBodyStyles.backgroundAttachment;
            // Restore original nav styles
            originalNavStyles.forEach(function(param) {
                var element = param.element, background = param.background;
                if (background) {
                    element.style.background = background;
                } else {
                    element.style.removeProperty("background");
                }
            });
            // Remove particles container content
            if (particlesRef.current) {
                particlesRef.current.innerHTML = "";
            }
        };
    }, []);
    // Particle effect for background
    (0,react.useEffect)(function() {
        // if (!showForm) return;
        // Only run on client side
        if (false) {}
        var container = particlesRef.current;
        if (!container) return;
        // Cleanup function
        var cleanup = function() {
            container.innerHTML = "";
            var style = document.getElementById("particles-style");
            if (style) style.remove();
        };
        // Create particles
        var createParticles = function() {
            cleanup(); // Clear existing particles
            var particleCount = 150;
            for(var i = 0; i < particleCount; i++){
                var particle = document.createElement("div");
                particle.classList.add("particle");
                var size = Math.random() * 3 + 1;
                var posX = Math.random() * 100;
                var posY = Math.random() * 100;
                var delay = Math.random() * 10;
                var duration = 20 + Math.random() * 30;
                var opacity = 0.2 + Math.random() * 0.5;
                Object.assign(particle.style, {
                    width: "".concat(size, "px"),
                    height: "".concat(size, "px"),
                    left: "".concat(posX, "%"),
                    top: "".concat(posY, "%"),
                    opacity: "".concat(opacity),
                    animation: "float ".concat(duration, "s ").concat(delay, "s infinite linear")
                });
                container.appendChild(particle);
            }
            var style = document.createElement("style");
            style.id = "particles-style";
            style.textContent = "\n                nav {background: transparent !important;}\n                nav.navbar-clone {display: none !important;}\n                @keyframes float {\n                    0% { transform: translate(0, 0) rotate(0deg); }\n                    100% { transform: translate(".concat(Math.random() * 100 - 50, "vw, ").concat(Math.random() * 100 - 50, "vh) rotate(360deg); }\n                }\n            ");
            document.head.appendChild(style);
        };
        createParticles();
    // return cleanup;
    }, []);
    var handleSubmit = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(e) {
            var submitBtn, loadingContainer, progressFill, loadingMessages, progress, currentMessage, interval, keywordsArray, res, json, hostname, result, screenshotStuff, fetchPageSpeed;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        e.preventDefault();
                        setLoading(true);
                        setError(null);
                        submitBtn = document.getElementById("submit-btn");
                        loadingContainer = document.getElementById("loading");
                        progressFill = document.getElementById("progress");
                        loadingMessages = [
                            "message1",
                            "message2",
                            "message3",
                            "message4",
                            "message5"
                        ].map(function(id) {
                            return document.getElementById(id);
                        });
                        //@ts-expect-error -gem
                        submitBtn.closest(".card").style.display = "none";
                        progress = 0;
                        currentMessage = 0;
                        loadingMessages[currentMessage].classList.add("active");
                        loadingContainer.style.display = "block";
                        interval = setInterval(function() {
                            progress += 1;
                            progressFill.style.width = "".concat(progress, "%");
                            if (progress % 10 === 0) {
                                loadingMessages[currentMessage].classList.remove("active");
                                currentMessage = (currentMessage + 1) % loadingMessages.length;
                                loadingMessages[currentMessage].classList.add("active");
                            }
                            if (progress >= 100) {
                                clearInterval(interval);
                                createCompletionParticles();
                                setTimeout(function() {
                                    loadingContainer.style.display = "none";
                                }, 800);
                            }
                        }, 900);
                        _ctx.prev = 13;
                        keywordsArray = keywords.split(",").map(function(kw) {
                            return kw.trim();
                        }).filter(function(kw) {
                            return kw.length > 0;
                        });
                        if (industry && !keywordsArray.includes(industry)) {
                            keywordsArray.unshift(industry);
                        }
                        _ctx.next = 18;
                        return fetch("/api/chaka", {
                            method: "POST",
                            headers: {
                                "Content-Type": "application/json"
                            },
                            body: JSON.stringify({
                                url: url,
                                keywords: keywordsArray
                            })
                        });
                    case 18:
                        res = _ctx.sent;
                        _ctx.next = 21;
                        return res.json();
                    case 21:
                        json = _ctx.sent;
                        hostname = Object.keys(json)[0];
                        result = json[hostname];
                        screenshotStuff = result.screenshotData[hostname];
                        // console.log("⚡️screenshot / elements stuff:", screenshotStuff);
                        setShowForm(false);
                        setShowReport(true);
                        // 6) store that in state 
                        setSiteData(screenshotStuff);
                        setDataLoaded(function(prev) {
                            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, prev), {
                                siteData: true
                            });
                        });
                        fetchPageSpeed = function() {
                            var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
                                var resPS, jsonresPS, hostnameresPS, resultresPS, pageSpeed, pageSpeedMobile;
                                return runtime_default().wrap(function _callee$(_ctx) {
                                    while(1)switch(_ctx.prev = _ctx.next){
                                        case 0:
                                            _ctx.next = 2;
                                            return fetch("/api/chaka/pageSpeedAPI", {
                                                method: "POST",
                                                headers: {
                                                    "Content-Type": "application/json"
                                                },
                                                body: JSON.stringify({
                                                    url: url,
                                                    keywords: keywordsArray
                                                })
                                            });
                                        case 2:
                                            resPS = _ctx.sent;
                                            _ctx.next = 5;
                                            return resPS.json();
                                        case 5:
                                            jsonresPS = _ctx.sent;
                                            hostnameresPS = Object.keys(jsonresPS)[0];
                                            resultresPS = jsonresPS[hostnameresPS];
                                            pageSpeed = resultresPS.pageSpeedData[hostnameresPS];
                                            pageSpeedMobile = resultresPS.pageSpeedDataMobile[hostnameresPS];
                                            setPageSpeedData(pageSpeed);
                                            setDataLoaded(function(prev) {
                                                return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, prev), {
                                                    pageSpeed: true
                                                });
                                            });
                                            setPageSpeedDataMobile(pageSpeedMobile);
                                            setDataLoaded(function(prev) {
                                                return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, prev), {
                                                    pageSpeedMobile: true
                                                });
                                            });
                                        case 14:
                                        case "end":
                                            return _ctx.stop();
                                    }
                                }, _callee);
                            }));
                            return function fetchPageSpeed() {
                                return _ref.apply(this, arguments);
                            };
                        }();
                        // Fetch without blocking UI
                        fetchPageSpeed();
                        _ctx.next = 36;
                        break;
                    case 33:
                        _ctx.prev = 33;
                        _ctx.t0 = _ctx["catch"](13);
                        //@ts-expect-error - gen
                        setError("Error: ".concat(_ctx.t0.message));
                    case 36:
                        _ctx.prev = 36;
                        setLoading(false);
                        return _ctx.finish(36);
                    case 39:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    13,
                    33,
                    36,
                    39
                ]
            ]);
        }));
        return function handleSubmit(e) {
            return _ref.apply(this, arguments);
        };
    }();
    var sortedElements = (0,_to_consumable_array/* default */.Z)((siteData === null || siteData === void 0 ? void 0 : siteData.elements) || []).filter(function(el) {
        return Array.isArray(el.boundingArea) && el.boundingArea.length === 4;
    }).sort(function(a, b) {
        var _boundingArea = (0,_sliced_to_array/* default */.Z)(a.boundingArea, 2), ax1 = _boundingArea[0], ay1 = _boundingArea[1];
        var _boundingArea1 = (0,_sliced_to_array/* default */.Z)(b.boundingArea, 2), bx1 = _boundingArea1[0], by1 = _boundingArea1[1];
        if (typeof ax1 !== "number" || typeof ay1 !== "number" || typeof bx1 !== "number" || typeof by1 !== "number") {
            return 0;
        }
        return ay1 - by1 || ax1 - bx1;
    });
    var sortedSiteData = siteData ? (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, siteData), {
        elements: sortedElements
    }) : null;
    if (error) {
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "col-10 col-md-8 col-lg-6 col-xl-5 mx-auto card mt-16",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "p-5",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                            className: "text-black",
                            style: {
                                color: "#333"
                            },
                            children: "Site Not Loading"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            children: "The website has failed to load. Have you typed in the full address correctly?"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                            children: [
                                "It may be that the server where this website is hosted is misconfigured or the security is too high for us to chcek the site. You can ",
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    className: "text-primary",
                                    style: {
                                        fontWeight: "bold",
                                        cursor: "pointer"
                                    },
                                    onClick: function() {
                                        return window.location.reload();
                                    },
                                    role: "button",
                                    tabIndex: 0,
                                    children: "try again"
                                }),
                                " or send us an email detailing the issue and we'll send you a manual report."
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(ContactFormOnlyChakaErrors, {
                    position: "center",
                    siteKey: url
                })
            ]
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(SEO/* default */.Z, {
                title: "SEOptimist London - SEO Audit",
                description: details.description,
                tag: details.categories,
                urlPT: "",
                urlENPT: "",
                url: "".concat(data_keywords.HomeList[0].title.toLowerCase().replace(/ /g, "-")),
                image: "img/".concat(data_keywords.HomeList[0].title.toLowerCase().replace(/ /g, "-"), ".jpg")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("main", {
                className: "",
                style: {
                    height: "100vh"
                },
                children: showForm ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "py-10 px-5",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "particles-container",
                            id: "particles",
                            ref: particlesRef
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "container-main",
                            style: {
                                maxWidth: 800,
                                margin: "0 auto",
                                position: "relative",
                                zIndex: 8,
                                minHeight: "100%",
                                boxSizing: "border-box"
                            },
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                                    className: "mx-auto mt-10 mb-5",
                                    style: {
                                        textAlign: "center",
                                        fontSize: "2.5rem",
                                        marginBottom: "0.5rem",
                                        background: "linear-gradient(to right, #4facfe, #00f2fe)",
                                        // -webkit-background-clip: "text",
                                        backgroundClip: "text",
                                        color: "transparent",
                                        textShadow: "0 0 10px rgba(79, 172, 254, 0.3)"
                                    },
                                    children: "Test Your Site"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    className: "subtitle text-center pb-10",
                                    style: {
                                        margin: "0 auto"
                                    },
                                    children: "Use our tool to see a snapshot of what is holding you back in Google, Bing and ChatGPT."
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "card cardy",
                                    style: {
                                        backdropFilter: "blur(10px)",
                                        borderRadius: "15px",
                                        padding: "2rem",
                                        boxShadow: "0 10px 30px rgba(0, 0, 0, 0.3)",
                                        border: "1px solid rgba(100, 120, 255, 0.2)",
                                        marginBottom: "2rem"
                                    },
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("form", {
                                        onSubmit: handleSubmit,
                                        className: "space-x-2 flex flex-col",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                                                style: {
                                                    color: "#666"
                                                },
                                                htmlFor: "url",
                                                children: "Enter your website address"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                                type: "text",
                                                value: url,
                                                onChange: function(e) {
                                                    var value = e.target.value.toLowerCase();
                                                    setUrl(value);
                                                },
                                                placeholder: "https://YourDomain.co.uk",
                                                className: "mb-6 form-control",
                                                required: true,
                                                name: "url"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                                                style: {
                                                    color: "#666"
                                                },
                                                htmlFor: "industry",
                                                children: "What is your industry?"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                                type: "text",
                                                value: industry,
                                                onChange: function(e) {
                                                    return setIndustry(e.target.value.toLowerCase());
                                                },
                                                placeholder: "Enter Industry",
                                                className: "mb-6 form-control",
                                                required: true,
                                                name: "industry"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                                                style: {
                                                    color: "#666"
                                                },
                                                htmlFor: "keywords",
                                                children: "Keywords you want to rank for (optional)"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                                type: "text",
                                                value: keywords,
                                                onChange: function(e) {
                                                    return setKeywords(e.target.value.toLowerCase());
                                                },
                                                placeholder: "Enter Keywords, comma separated",
                                                className: "mb-6 form-control",
                                                name: "keywords"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                                type: "submit",
                                                style: {
                                                    width: "100%",
                                                    background: "linear-gradient(to right, #5d7cff, #8e54e9)",
                                                    transition: "all 0.3s ease",
                                                    boxShadow: "0 5px 15px rgba(93, 124, 255, 0.4)"
                                                },
                                                className: "submit-btn btn btn-primary btn-send mb-3 d-inline-block",
                                                id: "submit-btn",
                                                children: "Analyse"
                                            })
                                        ]
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "card loading-container",
                            style: {
                                display: "none",
                                textAlign: "center",
                                padding: "2rem",
                                minHeight: "200px",
                                position: "relative"
                            },
                            id: "loading",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                    children: "Analysing Your Website"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "progress-container",
                                    style: {
                                        width: "100%",
                                        height: "20px",
                                        background: "rgba(10, 12, 30, 0.6)",
                                        borderRadius: "10px",
                                        margin: "2rem 0",
                                        overflow: "hidden",
                                        position: "relative",
                                        border: "1px solid rgba(100, 120, 255, 0.2)"
                                    },
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "progress-fill",
                                        style: {
                                            height: "100%",
                                            width: "0%",
                                            borderRadius: "10px",
                                            background: "linear-gradient(90deg, #5d7cff, #8e54e9, #ff6b9c, #ffd166)",
                                            transition: "width 0.5s ease"
                                        },
                                        id: "progress"
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "loading-messages",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "loading-message",
                                            id: "message1",
                                            children: "Preparing custom site audit..."
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "loading-message",
                                            id: "message2",
                                            children: "Analysing homepage content..."
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "loading-message",
                                            id: "message3",
                                            children: "Checking page load speed..."
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "loading-message",
                                            id: "message4",
                                            children: "Looking for important keywords..."
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "loading-message",
                                            id: "message5",
                                            children: "Reviewing image optimization..."
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "loading-message",
                                            id: "message6",
                                            children: "Checking mobile responsiveness..."
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "loading-message",
                                            id: "message7",
                                            children: "Analysing SEO meta tags..."
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "loading-message",
                                            id: "message8",
                                            children: "Reviewing heading structure..."
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "loading-message",
                                            id: "message9",
                                            children: "Checking for broken links..."
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "loading-message",
                                            id: "message10",
                                            children: "Evaluating content quality..."
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "loading-message",
                                            id: "message11",
                                            children: "Assessing security measures..."
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "loading-message",
                                            id: "message12",
                                            children: "Checking browser compatibility..."
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "loading-message",
                                            id: "message13",
                                            children: "Almost done, compiling report..."
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "mt-13",
                    style: {
                        backgroundColor: bgColor,
                        width: screenshotWidth + PADDING * 2,
                        height: screenshotHeight + PADDING * 2,
                        borderRadius: 8
                    },
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "relative order-1 order-lg-2",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "container pt-3",
                                    style: {
                                        textAlign: "center",
                                        margin: "0 auto"
                                    },
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("h1", {
                                                className: "mt-5",
                                                style: {
                                                    textAlign: "center",
                                                    margin: "0 auto 20px",
                                                    color: "#333"
                                                },
                                                children: [
                                                    "Report ",
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                        style: {
                                                            textTransform: "lowercase"
                                                        },
                                                        children: [
                                                            " for  ",
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("em", {
                                                                children: url.replace(/https?:\/\/(www\.)?|www\.|\//gi, "")
                                                            })
                                                        ]
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                className: "mx-auto mb-8 d-none d-md-block",
                                                children: "Our advanced analysis dives deep into your site’s code and content to uncover opportunities for improvement.   We give clear reports so you always know what we are doing. We only prioritise SEO tasks that actually make a significant difference to sales. "
                                            })
                                        ]
                                    })
                                }),
                                sortedSiteData && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(test_ScreenCanvas, {
                                            //@ts-expect-error - gen
                                            padding: PADDING,
                                            extraVerticalPadding: extraVerticalPadding,
                                            industrySector: industrySector,
                                            domain: url,
                                            siteData: sortedSiteData,
                                            imageRef: imageRef,
                                            screenshotWidth: screenshotWidth,
                                            screenshotHeight: screenshotHeight
                                        }),
                                        siteData && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(test_Report, {
                                                    siteData: siteData,
                                                    pageSpeed: pageSpeedData,
                                                    pageSpeedMobile: pageSpeedDataMobile,
                                                    domain: url
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    id: "full_report",
                                                    className: "mt-n10"
                                                })
                                            ]
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "mt-10",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                style: {
                                    background: "white"
                                },
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "col-10 col-md-8 col-lg-6 col-xl-5 mx-auto pt-10",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(common_ContactFormOnlyChaka4, {
                                        siteKey: url,
                                        position: "center"
                                    })
                                })
                            })
                        }),
                        " ",
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(portfolio/* Portfolio2 */.sc, {
                            title: "".concat(data_keywords.HomeList[7].title, "s")
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(testimonial/* Director */.tw, {
                            title: data_keywords.HomeList[6].title
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(LocalDI, {
                            heading: data_keywords.localSEOPackages[1].title,
                            initialslide: 0,
                            body: "Our local & Technical SEO, Social & PPC services target your exact demographic in the UK."
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(InternationalDI, {
                            heading: "".concat(data_keywords.HomeList[9].title, "s"),
                            body: "Our ".concat(data_keywords.HomeList[9].title, "s have developed SEO straegies and multilingual software for the biggest tech companies in\n                    the USA. We apply the same strategies to make your site visible in searches for European keywords.")
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "col-10 col-md-8 col-lg-6 col-xl-5 mx-auto pt-10",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(common_ContactFormOnlyChaka4, {
                                siteKey: url,
                                position: "center"
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(footer/* Footer1 */.gH, {
                            address: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                    children: [
                                        data_keywords.SiteIdentity[0].address1,
                                        ",",
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                        " ",
                                        data_keywords.SiteIdentity[0].address2,
                                        ",",
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                        " ",
                                        data_keywords.SiteIdentity[0].address3
                                    ]
                                })
                            ],
                            email: data_keywords.SiteIdentity[0].email,
                            phone: data_keywords.SiteIdentity[0].phone
                        })
                    ]
                })
            })
        ]
    });
};
//@ts-expect-error - gen
WebsiteComponent.bodyClass = "transparent";
/* harmony default export */ var test_your_website = (WebsiteComponent);


/***/ }),

/***/ 9511:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);


"use client";
var KeywordList = function(param) {
    var keywords = param.keywords;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        children: keywords && keywords.length > 0 ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("h3", {
                    children: [
                        "Your Industry",
                        keywords.length > 0 ? " Keywords:" : ":",
                        "              "
                    ]
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    style: {
                        display: "flex",
                        flexWrap: "wrap",
                        gap: "8px",
                        marginBottom: 20
                    },
                    children: keywords.map(function(kw, index) {
                        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                            style: {
                                color: "#111",
                                padding: "4px 16px",
                                backgroundColor: "#a5a5d9",
                                borderRadius: "9999px",
                                fontSize: "0.5rem"
                            },
                            children: kw
                        }, index);
                    })
                })
            ]
        }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
            children: "No keywords available for this site."
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (KeywordList);


/***/ }),

/***/ 3378:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "v": function() { return /* binding */ config; }
/* harmony export */ });
/* provided dependency */ var process = __webpack_require__(4155);
var screenshotWidth = 1920;
var screenshotHeight = 1080;
var padding = 130;
var extraVerticalPadding = 200;
var config = {
    screenshotWidth: screenshotWidth,
    screenshotHeight: screenshotHeight,
    padding: padding,
    extraVerticalPadding: extraVerticalPadding,
    canvasWidth: 1920 + padding * 2,
    canvasHeight: 1080 + padding * 2 + extraVerticalPadding,
    bgColor: "#eceef3",
    adjustedBgColor: "#eeedf2",
    maxTooltipWidth: 800,
    tooltipPadding: 10,
    tooltipBorderRadius: 16,
    industrySector: "solicitor",
    fontSizes: [
        process.env.SCREENSHOT_FONT_SIZE_LG || "34",
        process.env.SCREENSHOT_FONT_SIZE_MD || "44",
        process.env.SCREENSHOT_FONT_SIZE_SM || "54"
    ],
    slots: [
        {
            y: 2,
            x: 10,
            width: 1000,
            height: 100
        },
        {
            y: 5,
            x: 1150,
            width: 100,
            height: 100
        },
        {
            y: 400,
            x: 10,
            maxWidth: 500,
            width: 100,
            height: 100
        },
        {
            y: 1210,
            x: 20,
            width: 100,
            height: 100
        },
        {
            y: 1190,
            x: 1120,
            width: 100,
            height: 100
        }
    ],
    lineWidth: 2
};


/***/ }),

/***/ 6422:
/***/ (function() {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ 5774:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Ip": function() { return /* binding */ CircularProgressbar; },
/* harmony export */   "y3": function() { return /* binding */ buildStyles; }
/* harmony export */ });
/* unused harmony export CircularProgressbarWithChildren */
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7294);


/*! *****************************************************************************
Copyright (c) Microsoft Corporation. All rights reserved.
Licensed under the Apache License, Version 2.0 (the "License"); you may not use
this file except in compliance with the License. You may obtain a copy of the
License at http://www.apache.org/licenses/LICENSE-2.0

THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
MERCHANTABLITY OR NON-INFRINGEMENT.

See the Apache Version 2.0 License for specific language governing permissions
and limitations under the License.
***************************************************************************** */
/* global Reflect, Promise */

var extendStatics = function(d, b) {
    extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return extendStatics(d, b);
};

function __extends(d, b) {
    extendStatics(d, b);
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}

var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};

function __rest(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
}

var VIEWBOX_WIDTH = 100;
var VIEWBOX_HEIGHT = 100;
var VIEWBOX_HEIGHT_HALF = 50;
var VIEWBOX_CENTER_X = 50;
var VIEWBOX_CENTER_Y = 50;

function Path(_a) {
    var className = _a.className, counterClockwise = _a.counterClockwise, dashRatio = _a.dashRatio, pathRadius = _a.pathRadius, strokeWidth = _a.strokeWidth, style = _a.style;
    return ((0,react__WEBPACK_IMPORTED_MODULE_0__.createElement)("path", { className: className, style: Object.assign({}, style, getDashStyle({ pathRadius: pathRadius, dashRatio: dashRatio, counterClockwise: counterClockwise })), d: getPathDescription({
            pathRadius: pathRadius,
            counterClockwise: counterClockwise,
        }), strokeWidth: strokeWidth, fillOpacity: 0 }));
}
function getPathDescription(_a) {
    var pathRadius = _a.pathRadius, counterClockwise = _a.counterClockwise;
    var radius = pathRadius;
    var rotation = counterClockwise ? 1 : 0;
    return "\n      M " + VIEWBOX_CENTER_X + "," + VIEWBOX_CENTER_Y + "\n      m 0,-" + radius + "\n      a " + radius + "," + radius + " " + rotation + " 1 1 0," + 2 * radius + "\n      a " + radius + "," + radius + " " + rotation + " 1 1 0,-" + 2 * radius + "\n    ";
}
function getDashStyle(_a) {
    var counterClockwise = _a.counterClockwise, dashRatio = _a.dashRatio, pathRadius = _a.pathRadius;
    var diameter = Math.PI * 2 * pathRadius;
    var gapLength = (1 - dashRatio) * diameter;
    return {
        strokeDasharray: diameter + "px " + diameter + "px",
        strokeDashoffset: (counterClockwise ? -gapLength : gapLength) + "px",
    };
}

var CircularProgressbar = (function (_super) {
    __extends(CircularProgressbar, _super);
    function CircularProgressbar() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    CircularProgressbar.prototype.getBackgroundPadding = function () {
        if (!this.props.background) {
            return 0;
        }
        return this.props.backgroundPadding;
    };
    CircularProgressbar.prototype.getPathRadius = function () {
        return VIEWBOX_HEIGHT_HALF - this.props.strokeWidth / 2 - this.getBackgroundPadding();
    };
    CircularProgressbar.prototype.getPathRatio = function () {
        var _a = this.props, value = _a.value, minValue = _a.minValue, maxValue = _a.maxValue;
        var boundedValue = Math.min(Math.max(value, minValue), maxValue);
        return (boundedValue - minValue) / (maxValue - minValue);
    };
    CircularProgressbar.prototype.render = function () {
        var _a = this.props, circleRatio = _a.circleRatio, className = _a.className, classes = _a.classes, counterClockwise = _a.counterClockwise, styles = _a.styles, strokeWidth = _a.strokeWidth, text = _a.text;
        var pathRadius = this.getPathRadius();
        var pathRatio = this.getPathRatio();
        return ((0,react__WEBPACK_IMPORTED_MODULE_0__.createElement)("svg", { className: classes.root + " " + className, style: styles.root, viewBox: "0 0 " + VIEWBOX_WIDTH + " " + VIEWBOX_HEIGHT, "data-test-id": "CircularProgressbar" },
            this.props.background ? ((0,react__WEBPACK_IMPORTED_MODULE_0__.createElement)("circle", { className: classes.background, style: styles.background, cx: VIEWBOX_CENTER_X, cy: VIEWBOX_CENTER_Y, r: VIEWBOX_HEIGHT_HALF })) : null,
            (0,react__WEBPACK_IMPORTED_MODULE_0__.createElement)(Path, { className: classes.trail, counterClockwise: counterClockwise, dashRatio: circleRatio, pathRadius: pathRadius, strokeWidth: strokeWidth, style: styles.trail }),
            (0,react__WEBPACK_IMPORTED_MODULE_0__.createElement)(Path, { className: classes.path, counterClockwise: counterClockwise, dashRatio: pathRatio * circleRatio, pathRadius: pathRadius, strokeWidth: strokeWidth, style: styles.path }),
            text ? ((0,react__WEBPACK_IMPORTED_MODULE_0__.createElement)("text", { className: classes.text, style: styles.text, x: VIEWBOX_CENTER_X, y: VIEWBOX_CENTER_Y }, text)) : null));
    };
    CircularProgressbar.defaultProps = {
        background: false,
        backgroundPadding: 0,
        circleRatio: 1,
        classes: {
            root: 'CircularProgressbar',
            trail: 'CircularProgressbar-trail',
            path: 'CircularProgressbar-path',
            text: 'CircularProgressbar-text',
            background: 'CircularProgressbar-background',
        },
        counterClockwise: false,
        className: '',
        maxValue: 100,
        minValue: 0,
        strokeWidth: 8,
        styles: {
            root: {},
            trail: {},
            path: {},
            text: {},
            background: {},
        },
        text: '',
    };
    return CircularProgressbar;
}(react__WEBPACK_IMPORTED_MODULE_0__.Component));

function CircularProgressbarWithChildren(props) {
    var children = props.children, circularProgressbarProps = __rest(props, ["children"]);
    return (createElement("div", { "data-test-id": "CircularProgressbarWithChildren" },
        createElement("div", { style: { position: 'relative', width: '100%', height: '100%' } },
            createElement(CircularProgressbar, __assign({}, circularProgressbarProps)),
            props.children ? (createElement("div", { "data-test-id": "CircularProgressbarWithChildren__children", style: {
                    position: 'absolute',
                    width: '100%',
                    height: '100%',
                    marginTop: '-100%',
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: 'center',
                    alignItems: 'center',
                } }, props.children)) : null)));
}

function buildStyles(_a) {
    var rotation = _a.rotation, strokeLinecap = _a.strokeLinecap, textColor = _a.textColor, textSize = _a.textSize, pathColor = _a.pathColor, pathTransition = _a.pathTransition, pathTransitionDuration = _a.pathTransitionDuration, trailColor = _a.trailColor, backgroundColor = _a.backgroundColor;
    var rotationTransform = rotation == null ? undefined : "rotate(" + rotation + "turn)";
    var rotationTransformOrigin = rotation == null ? undefined : 'center center';
    return {
        root: {},
        path: removeUndefinedValues({
            stroke: pathColor,
            strokeLinecap: strokeLinecap,
            transform: rotationTransform,
            transformOrigin: rotationTransformOrigin,
            transition: pathTransition,
            transitionDuration: pathTransitionDuration == null ? undefined : pathTransitionDuration + "s",
        }),
        trail: removeUndefinedValues({
            stroke: trailColor,
            strokeLinecap: strokeLinecap,
            transform: rotationTransform,
            transformOrigin: rotationTransformOrigin,
        }),
        text: removeUndefinedValues({
            fill: textColor,
            fontSize: textSize,
        }),
        background: removeUndefinedValues({
            fill: backgroundColor,
        }),
    };
}
function removeUndefinedValues(obj) {
    Object.keys(obj).forEach(function (key) {
        if (obj[key] == null) {
            delete obj[key];
        }
    });
    return obj;
}


//# sourceMappingURL=index.esm.js.map


/***/ }),

/***/ 828:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ _slicedToArray; }
});

;// CONCATENATED MODULE: ./node_modules/@swc/helpers/src/_array_with_holes.mjs
function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_iterable_to_array.mjs
var _iterable_to_array = __webpack_require__(3375);
;// CONCATENATED MODULE: ./node_modules/@swc/helpers/src/_non_iterable_rest.mjs
function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_unsupported_iterable_to_array.mjs
var _unsupported_iterable_to_array = __webpack_require__(1566);
;// CONCATENATED MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs





function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || (0,_iterable_to_array/* default */.Z)(arr, i) || (0,_unsupported_iterable_to_array/* default */.Z)(arr, i) || _nonIterableRest();
}


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [2634,1271,7857,4870,4556,6435,362,4022,659,9774,2888,179], function() { return __webpack_exec__(701); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);